<template>
  <div>
    <v-dialog v-model="value" max-width="870" scrollable @click:outside="dismiss()">
      <v-form @submit.prevent="onSubmit()" ref="form" :lazy-validation="true">
        <v-card v-if="!isLoading" class="pb-2">
          <v-card-title class="
              d-flex
              justify-space-between
              align-center
              green
              white--text
              py-2
            ">
            <span>
              <span v-if="dialogType == 'refund'">{{ $t('payment.refund_payment') }}</span>
              <span v-else-if="dialogType == 'extra'">{{ $t('payment.title') }}</span>
            </span>
            <span>
              <v-icon @click="dismiss()" color="white">
                mdi-close
              </v-icon>
            </span>
          </v-card-title>
          <v-card-text class="px-0 py-0">
            <div class="d-flex justify-center align-center c-1" v-if="isLoading">
              <v-progress-circular indeterminate color="green" size="50"></v-progress-circular>
            </div>
            <div class="grid-container-payment" v-else>
              <div class="grd-1">
                <div class="header-payment-fixed">
                  <div class="box-wht" v-if="isWht">
                    <div class="d-flex justify-space-between py-1 pb-2">
                      <div>{{ $t('market.total_value') }}</div>
                      <div>
                        <div v-if="invoice">{{ invoice.totalUnpaidValue | currency }} {{ currencyThEn }}</div>
                        <div v-else-if="receipt">{{ receipt.totalValue | currency }} {{ currencyThEn }}</div>
                        <div v-else-if="order">{{ order.totalValue | currency }} {{ currencyThEn }}</div>
                        <div v-else>0 {{ currencyThEn }}</div>
                      </div>
                    </div>
                    <div class="d-flex justify-space-between py-1">
                      <div>{{ $t('tax.tax_withholding') }}</div>
                      <div>
                        <div v-if="invoice">{{ invoice.totalWhtValue | currency }} {{ currencyThEn }}</div>
                        <div v-else-if="receipt">{{ receipt.totalWhtValue | currency }} {{ currencyThEn }}</div>
                        <div v-else-if="order">{{ order.totalWhtValue | currency }} {{ currencyThEn }}</div>
                        <div v-else>0 {{ currencyThEn }}</div>

                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-space-between total-pay">
                    <div v-if="dialogType == 'refund'">{{ $t('payment.amount_to_refund') }}</div>
                    <div v-else>{{ $t('payment.remaining_amount_payment') }}</div>
                    <div> {{ totalUnpaidValue | currency }} {{ currencyThEn }}</div>
                  </div>
                </div>
                <div class="body-payment">
                  <div class="mt-4 mb-2">
                    <div class="d-flex justify-space-between">
                      <div class="text-header">
                        <b v-if="dialogType == 'refund'">{{ $t('payment.select_refund_type') }}</b>
                        <b v-else>{{ $t('payment.select_payment_type') }}</b>
                      </div>
                      <div v-if="invoice && !receipt && formData.paymentType == 'full'" @click="onClickSplitVatNonVat()">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <a class="blue--text icon-setting-box" v-bind="attrs" v-on="on"
                              :style="isQrPayment ? 'pointer-events: none; filter: grayscale(100%); opacity: 0.5' : ''">
                              <v-icon color="blue" size="20">mdi-cog-outline</v-icon>
                              {{ $t('setup') }}
                            </a>
                          </template>
                          <v-list>
                            <v-list-item>
                              <v-checkbox v-model="formData.isSplitVatNonVat" class="my-0 py-0"
                                :label="$t('tax.split_receipt_in_tax_list')" hide-details @click="onChageSplitVatNonVat"></v-checkbox>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                    <div class="ps-1" v-if="invoice && !receipt && formData.paymentType == 'full'">
                      <div v-if="formData.isSplitVatNonVat" style="font-size: 13px;">
                        {{ $t('tax.split_receipt_in_tax_list_description') }}</div>
                    </div>
                  </div>

                  <v-radio-group v-model="formData.paymentType" row hide-details class="mt-0">
                    <v-row no-gutters>
                      <v-col :cols="isHideSplitPay ? 12 : 6" style="padding: 0px 7px;"
                        @click="onClickPaymentType('full')">
                        <v-radio :label="$t('payment.pay_in_full')" value="full" class="box-radio"
                          :style="isQrPayment ? 'pointer-events: none;' : ''"></v-radio>
                      </v-col>
                      <v-col v-if="!isHideSplitPay" cols="6" style="padding: 0px 7px;"
                        @click="!isWht ? onClickPaymentType('split') : null">
                        <v-radio :label="$t('payment.pay_in_split')" value="split" class="box-radio" :disabled="isWht"
                          :style="isQrPayment ? 'pointer-events: none;' : ''"></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>

                  <div class="mt-4 mb-2" v-if="invoice && !receipt && formData.paymentType == 'split'">
                    <div class="text-header">
                      <b>{{ $t('payment.split_payment_detail') }}</b>
                    </div>
                    <v-radio-group v-model="formData.splitType" row hide-details class="mt-2">
                      <v-row no-gutters>
                        <v-col cols="6" style="padding: 0px 7px;" @click="onClickSplitType('amount')">
                          <v-radio :label="$t('payment.specify_amount')" value="amount" class="box-radio"
                            :disabled="isQrPayment"></v-radio>
                        </v-col>
                        <v-col cols="6" style="padding: 0px 7px;" @click="onClickSplitType('item')">
                          <v-radio :label="$t('select_list')" value="item" class="box-radio" :disabled="isQrPayment"></v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>

                    <div v-if="formData.paymentType == 'split' && formData.splitType == 'amount'">
                      <div class="box-bg-input mt-3">
                        <v-currency-field v-model="formData.amount"
                          :rules="[rules.required, rules.min, rules.max]" class="input-disable-appearance input-bg-white"
                          :placeholder="$t('payment.specify_amount')" outlined :suffix="currencyThEn" min="1" small hide-details="auto"
                          :disabled="isQrPayment" @input="(value) => (formData.amount = parseFloat(formData.amount))" />
                      </div>
                    </div>
                    <div class="mt-3" v-if="formData.paymentType == 'split' && formData.splitType == 'item'">
                      <v-data-table
                        v-model="tempReceipt.items"
                        :headers="dataTable.headers"
                        :items="groupedStallData"
                        :single-select="isQrPayment ? true : false"
                        hide-default-footer
                        show-select
                        group-by="stallName"
                        class="split-item-table"
                        style="background-color: #E9F5EA;"
                        :no-data-text="$t('noinfo')"
                        :no-results-text="$t('no_matching_records_found')">
                      >
                        <template v-slot:header.data-table-select>
                          <div></div>
                        </template>
                        <template v-slot:group="{ group, items: groupItems }">
                          <tr>
                            <td class="group-name-table px-2" colspan="4">
                              <div
                                :class="isQrPayment ? 'ps-3' : ''"
                                class="d-flex align-center"
                              >
                                <v-simple-checkbox
                                  :value="isGroupSelected(groupItems[0])"
                                  @input="toggleGroupSelection(groupItems[0])"
                                  :disabled="isQrPayment"
                                  color="success"
                                />
                                <span class="font-weight-bold group-name">{{ group }}</span>
                              </div>
                            </td>
                          </tr>
                          <template v-for="(item, index) in groupItems[0].items">
                            <tr></tr>
                              <td class="pl-4 py-3">
                                <div class="col-item-split pl-2"
                                  :class="isQrPayment ? 'ps-3' : ''"
                                  style="border-radius: 5px 0px 0px 5px; "
                                >
                                  <v-simple-checkbox
                                    :value="isSelected(item)"
                                    @input="select(item, !isSelected(item))"
                                    :disabled="isQrPayment"
                                    color="success"
                                  />
                                </div>
                              </td>
                              <td class="px-0 py-3">
                                <div
                                  class="col-item-split ps-2"
                                  style="justify-content: start; white-space: nowrap;"
                                >
                                  {{ item.name }}
                                </div>
                              </td>
                              <td class="px-0 py-3">
                                <div class="col-item-split">
                                  <template v-if="item.sellVatType == 1">V</template>
                                  <template v-else>{{ $t('except') }}</template>
                                </div>
                              </td>
                              <td class="px-0 py-3 pe-4">
                                <div class="col-item-split pe-2"
                                  style="border-radius: 0px 5px 5px 0px; justify-content: end;">
                                  {{ item.totalValue | currency }}
                                </div>
                              </td>
                            </tr>
                          </template>
                        </template>
                      </v-data-table>
                      <div class="text-center mt-4">
                        <div class="split-total">{{ $t('sum') }} : {{ tempReceipt.totalValue | currency }} {{ currencyThEn }}</div>
                        <p v-if="!tempReceipt.totalValue || tempReceipt.totalValue > invoice.totalUnpaidValue"
                          class="red--text" style="font-size: 13px;">
                          {{ $t('payment.pay_in_split_not_exceed_space') }} {{ invoice.totalUnpaidValue | currency }} {{ currencyThEn }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div v-if="$helper.currencyOptions.length > 1">
                    <v-divider class="my-3"></v-divider>
                    <v-row class="align-center">
                      <v-col cols="5">
                        <div class="text-sub-header">{{ $t('payment.select_payment_currency') }}</div>
                      </v-col>
                      <v-col cols="7">
                        <CurrencySelect 
                          v-model="formData.paymentCurrencyCode"
                          :disabled="isContractCheckout"
                          @change="changePaymentCurrencyCode"
                          :label="$t('payment.select_currency')"
                        />
                      </v-col>
                    </v-row>

                    <template v-if="formData.paymentCurrencyCode != currencyCode">
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <div class="d-flex justify-end">
                            <v-menu
                              v-model="menuPaymentRate"
                              :close-on-content-click="false"
                              :close-on-click="false"
                              right
                              top
                              :offset-x="true"
                              :max-width="540"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on" v-bind="attrs" elevation="0" color="#D3EAFD" class="info--text">
                                  1 {{ $helper.currencyThEn(formData.paymentCurrencyCode) }} = {{ formData.exchangeRate | currencySuffixTextThEn(currencyCode, { isExchangeRate: true }) }}
                                </v-btn>
                              </template>
                              <v-form @submit.prevent="savePaymentRate()" ref="formPaymentRate">
                                <v-card class="main-card-exchange">
                                  <v-card-text class="container-card-exchange">
                                    <div class="header-card-exchange">
                                      <div class="title-card-exchange">{{ $t('payment.edit_exchange_rate') }}</div>
                                      <div class="close-card-exchange" @click="menuPaymentRate = false">
                                        <v-icon>mdi-close</v-icon>
                                      </div>
                                    </div>
                                    <div class="body-card-exchange">
                                      <div class="d-flex justify-space-between mb-2">
                                        <div>{{ $t('payment.invoice_currency') }}:</div>
                                        <div class="d-flex align-items-center">
                                          <div class="icon-currency-avatar">
                                            <img :src="`/images/currency/${currencyCode}.svg`" width="20" height="20" class="icon-currency" alt="currency"/>
                                          </div>  
                                          <div>{{ $helper.currencyOptionName(currencyCode) }}</div>
                                        </div>
                                      </div>
                                      <div class="d-flex justify-space-between mb-2">
                                        <div>{{ $t('payment.payment_currency') }}:</div>
                                        <div class="d-flex align-items-center">
                                          <div class="icon-currency-avatar">
                                            <img :src="`/images/currency/${formData.paymentCurrencyCode}.svg`" width="20" height="20" class="icon-currency" alt="currency"/>
                                          </div>
                                          <div>{{ $helper.currencyOptionName(formData.paymentCurrencyCode) }}</div>
                                        </div>
                                      </div>
                                      <v-radio-group v-model="formData.exchangeRateType" row hide-details class="mt-0">
                                        <div class="box-radio-exchange mb-4" :class="formData.exchangeRateType == 'auto' ? 'active' : ''" @click="radioTypeExchange('auto')">
                                          <div class="d-flex justify-space-between align-start">
                                            <div class="d-flex align-start">
                                              <v-radio value="auto" class="me-1"></v-radio>
                                              <div class="d-flex flex-column">
                                                <div class="d-flex align-items-center">
                                                  <div class="me-2">{{ $t('payment.exchange_rate_on_date') }} 
                                                    <template v-if="currencyRate">
                                                      {{ $moment(currencyRate.lastUpdate).format("DD MMM YYYY") }}
                                                    </template>
                                                  </div>
                                                  <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-icon small color="info" v-bind="attrs" v-on="on">mdi-information</v-icon>
                                                    </template>
                                                    <div>{{ $t('payment.reference_data_from') }} 
                                                      <span v-if="currencyRate">{{ currencyRate.website }}</span>
                                                    </div>
                                                    <div v-if="currencyRate">{{ $t('payment.on_date') }} {{ $moment(currencyRate.lastUpdate).format("DD MMMM YYYY") }} {{ $t('full_time', { time: $moment(currencyRate.lastUpdate).format("HH:mm:ss") }) }}</div>
                                                  </v-tooltip>
                                                </div>
                                                <div class="mt-2">1 {{ $helper.currencyThEn(formData.paymentCurrencyCode) }} = 
                                                  <template v-if="getExchangeRate(formData.paymentCurrencyCode, currencyCode)">
                                                    {{ getExchangeRate(formData.paymentCurrencyCode, currencyCode) | currencySuffixTextThEn(currencyCode, { isExchangeRate: true }) }}
                                                  </template>
                                                  <template v-else>
                                                    {{ 0 | currencySuffixTextThEn(currencyCode, { isExchangeRate: true }) }}
                                                  </template>
                                                </div>
                                              </div>
                                            </div>
                                            <v-menu
                                              v-model="menuPaymentRateDate"
                                              :close-on-content-click="false"
                                              transition="scale-transition"
                                              offset-x
                                              left
                                              bottom
                                              min-width="auto"
                                            >
                                              <template v-slot:activator="{ on, attrs }">
                                                <img 
                                                  src="@/assets/icons/calendar.svg" 
                                                  alt="calendar" 
                                                  width="24" 
                                                  height="24"
                                                  v-bind="attrs"
                                                  v-on="on"
                                                  class="ms-2 icon-calendar"
                                                />
                                              </template>
                                              <v-date-picker
                                                v-model="formData.exchangeRateDate"
                                                @input="menuPaymentRateDate = false; initCurrencyRate(formData.exchangeRateDate)"
                                                no-title
                                                scrollable
                                                locale="th"
                                                :max="new Date().toISOString().substr(0, 10)"
                                                :header-date-format="$helper.headerDateFormat"
                                                :year-format="$helper.yearFormat"
                                                :weekday-format="$helper.formatWeekday"
                                                :month-format="$helper.formatMonth"
                                              >
                                              </v-date-picker>
                                            </v-menu>
                                          </div>
                                        </div>
        
                                        <div class="box-radio-exchange" :class="formData.exchangeRateType == 'manual' ? 'active' : ''" @click="radioTypeExchange('manual')">
                                          <div class="d-flex justify-space-between align-start">
                                            <div class="d-flex align-start">
                                              <v-radio value="manual" class="me-1"></v-radio>
                                              <div class="d-flex flex-column">
                                                <div class="d-flex align-items-center">
                                                  <div class="me-2">{{ $t('payment.manual_exchange_rate') }}</div>
                                                </div>
                                                <div class="mt-2">
                                                  <div class="d-flex align-center">
                                                    <div class="me-2">1 {{ $helper.currencyThEn(formData.paymentCurrencyCode) }} = </div>
                                                    <v-currency-field 
                                                      v-model="formData.manualExchangeRate" 
                                                      class="input-disable-appearance input-bg-white"
                                                      placeholder="0.0000"
                                                      outlined
                                                      dense
                                                      small
                                                      hide-details
                                                      ref="manualExchangeRate"
                                                      @input="(value) => formData.manualExchangeRate ? formData.manualExchangeRate = parseFloat(formData.manualExchangeRate) : formData.manualExchangeRate = null"
                                                      :rules="formData.exchangeRateType == 'manual' ? [rules.required, rules.min] : []" 
                                                      :options="{ precision: {} }" 
                                                    />
                                                    <div class="ms-2">{{ $helper.currencyThEn(currencyCode) }}</div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
        
                                      </v-radio-group>
                                    </div>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      class="success"
                                      text
                                      type="submit"
                                      :disabled="isLoadingCurrencyRate"
                                    >
                                      {{ $t('save') }}
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-form>
                            </v-menu>
                          </div>
                        </v-col>
                      </v-row>
    
                      <v-row class="align-center">
                        <v-col cols="5">
                          <div class="text-sub-header">{{ $t('payment.actual_payment_amount') }}</div>
                        </v-col>
                        <v-col cols="7">
                          <div class="d-flex align-center align-items-center">
                            <v-currency-field 
                              v-model="formData.totalPaymentValue"
                              :rules="[rules.required]"
                              class="input-disable-appearance input-bg-white"
                              :placeholder="$t('payment.specify_amount_placeholder')"
                              outlined
                              dense
                              small
                              hide-details
                              :options="{
                                precision: {
                                  min: 2,
                                  max: 2
                                }
                              }"
                              @input="(value) => (formData.totalPaymentValue = parseFloat(formData.totalPaymentValue))"
                            />
                            <div class="text-sub-header ms-2">{{ $helper.currencyThEn(formData.paymentCurrencyCode) }}</div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="align-center">
                        <v-col cols="5">
                          <div class="text-sub-header">{{ $t('payment.exchange_profit_loss') }}</div>
                        </v-col>
                        <v-col cols="7">
                          <div class="d-flex justify-space-between align-items-center">
                            <div>
                              <span class="text-sub-header" :class="calculateExchangeRate.profit > 0 ? 'success--text' : calculateExchangeRate.profit < 0 ? 'error--text' : ''"> {{ calculateExchangeRate.profit | currency(null, { isShowPlus: true }) }}</span>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon small color="info" v-bind="attrs" v-on="on" class="ms-1">mdi-information</v-icon>
                                </template>
                                <span><b>{{ $t('payment.calculation_method') }}</b></span>
                                <v-divider class="my-2 bg-white"></v-divider>
                                <div v-for="(step, index) in calculateExchangeRate.steps" :key="'step-'+index">{{ step }}</div>
                                <v-divider class="my-2 bg-white"></v-divider>
                                <div><b><u>{{ $t('payment.actual_calculation') }}</u></b></div>
                                <div v-for="(calc, index) in calculateExchangeRate.calculation" :key="'calc-'+index">{{ calc }}</div>
                                <div><b>{{ calculateExchangeRate.result }}</b></div>
                              </v-tooltip>
                            </div>
                            <div class="text-sub-header ms-2">
                              {{ $helper.currencyThEn(currencyCode) }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </div>
                </div>
              </div>

              <div class="grd-2">
                <div class="body-payment">
                  <div class="text-header">
                    <b v-if="dialogType == 'refund'">{{ $t('payment.refund_channel') }}</b>
                    <b v-else>{{ $t('payment.pay_method') }}</b>
                  </div>
                  <v-radio-group class="mt-0" v-model="formData.paymentMethod" row hide-details
                    style="padding-left: -100px;">
                    <v-row no-gutters>
                      <v-col cols="6" style="padding: 7px;" @click="onClickPaymentMethod(1)">
                        <v-radio :label="$t('payment.cash')" :value="1" class="box-radio" :disabled="isQrPayment" />
                      </v-col>
                      <v-col cols="6" style="padding: 7px;" @click="onClickPaymentMethod(2)">
                        <v-radio :label="$t('payment.transfer_money')" :value="2" class="box-radio" :disabled="isQrPayment" />
                      </v-col>
                      <v-col cols="6" style="padding: 7px;" @click="onClickPaymentMethod(6)">
                        <v-radio :label="$t('payment.cash_check')" :value="6" class="box-radio" :disabled="isQrPayment" />
                      </v-col>
                      <v-col cols="6" v-if="dialogType != 'refund'" style="padding: 7px;"
                        @click="onClickPaymentMethod(3)">
                        <v-radio :label="$t('payment.credit_debit')" :value="3" class="box-radio" :disabled="isQrPayment" />
                      </v-col>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-col v-bind="attrs" v-on="formData.isSplitVatNonVat ? on : null" cols="6"
                            v-if="dialogType != 'refund' && isQRPaymentSetting" style="padding: 7px;"
                            @click="!formData.isSplitVatNonVat ? onClickQrPayment() : null">
                            <v-radio label="QR PAYMENT" :value="7" class="box-radio" style="pointer-events: none;"
                              :disabled="formData.isSplitVatNonVat" />
                          </v-col>
                        </template>
                        <span>{{ $t('validate.qr_payment_cannot_split_receipt') }}</span>
                      </v-tooltip>
                      <v-col cols="6" style="padding: 7px;" @click="onClickPaymentMethod(8)">
                        <v-radio :label="$t('payment.gift_voucher')" :value="8" class="box-radio warp-text" :disabled="isQrPayment" />
                      </v-col>
                    </v-row>
                  </v-radio-group>

                  <div class="mt-4">
                    <div class="text-header">
                      <b v-if="dialogType == 'refund'">{{ $t('payment.refund_detail') }}</b>
                      <b v-else>{{ $t('payment.payment_detail_only') }}</b>
                    </div>
                    <template v-if="dialogType == 'refund'">
                      <v-row class="mt-1" v-if="formData.paymentMethod != 7">
                        <v-col cols="5" class="d-flex align-center">
                          <div class="text-sub-header">
                            {{ dialogType == 'refund' ? $t('payment.payment_refund_date') : $t('payment.payment_received_date') }} <span class="red--text">*</span>
                          </div>
                        </v-col>
                        <v-col cols="7">
                          <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition"
                            offset-y max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :value="$moment(formData.date).format('D MMM YYYY')" :placeholder="$t('date')"
                                outlined hide-details readonly v-bind="attrs" v-on="on" dense
                                prepend-inner-icon="mdi-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="formData.date" no-title @input="menuDate = false"
                              :header-date-format="$helper.headerDateFormat"
                              :weekday-format="$helper.formatWeekday"
                              :month-format="$helper.formatMonth"
                              :year-format="$helper.yearFormat"
                              locale="th"
                              ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12">
                          <v-row class="mb-2" no-gutters justify="center" v-if="tempFiles.length">
                            <template v-for="(file, index) in tempFiles">
                              <v-col :key="index" cols="6" class="px-2">
                                <v-card>
                                  <v-img :src="file.url ? file.url : fileToUrl(file)">
                                    <v-app-bar flat color="rgba(0, 0, 0, 0)">
                                      <v-spacer></v-spacer>
                                      <v-btn style="margin: -25px -15px 0 0" class="error white--text" elevation="2" icon
                                        rounded small @click="removeFile(index)"><v-icon>mdi-close</v-icon></v-btn>
                                    </v-app-bar>
                                  </v-img>
                                </v-card>
                              </v-col>
                            </template>
                          </v-row>
                          <div class="box-upload">
                            <div style="height: fit-content;">
                              <div class="btn-upload" @click="openFileDialog()">
                                Upload <v-icon class="text-upload">mdi-upload</v-icon>
                              </div>
                              <div>Files supported: PNG, JPEG</div>
                            </div>
                          </div>
                          <input ref="uploader" class="input-center d-none" :placeholder="$t('attach_proof')" outlined hide-details
                            clear-icon prepend-icon="" type="file" accept="image/*" @input="onUploadImage($event)" />
                        </v-col>

                        <v-col cols="12" v-if="formData.paymentMethod != 7">
                          <div class="text-sub-header">
                            {{ $t('note') }}
                          </div>
                          <v-textarea v-model="formData.paymentNote" class="input-center mt-3" :placeholder="$t('note')"
                            outlined hide-details rows="3" no-resize></v-textarea>
                        </v-col>
                      </v-row>
                    </template>

                    <template v-else>
                      <v-row class="mt-1" v-if="formData.paymentMethod != 7">
                        <v-col cols="5" class="d-flex align-center">
                          <div class="text-sub-header">
                            {{ $t('payment.payment_received_date') }} <span class="red--text">*</span>
                          </div>
                        </v-col>
                        <v-col cols="7">
                          <v-menu v-model="menuDate" :close-on-content-click="false" transition="scale-transition"
                            offset-y max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :value="$moment(formData.date).format('D MMM YYYY')" :placeholder="$t('date')"
                                outlined hide-details readonly v-bind="attrs" v-on="on" dense
                                prepend-inner-icon="mdi-calendar"></v-text-field>
                            </template>
                            <v-date-picker v-model="formData.date" no-title @input="menuDate = false"
                              :header-date-format="$helper.headerDateFormat"
                              :year-format="$helper.yearFormat"
                              locale="th"
                              :weekday-format="$helper.formatWeekday"
                              :month-format="$helper.formatMonth"
                              ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" v-if="formData.paymentMethod == 2 || formData.paymentMethod == 6">
                          <div class="text-sub-header">
                            {{ $t('payment.access_to_bank_account') }}
                          </div>
                          <v-select :disabled="isLoadingBankAccounts" v-model="formData.paymentBankAccount"
                            :items="bankAccounts || []" item-text="accountName" item-value="objectId"
                            class="input-center select-bank mt-3" :placeholder="$t('payment.access_to_bank_account')" outlined hide-details
                            :rules="isSubmitFromQr ? [] : [rules.required]">
                            <template v-slot:selection="{ item }">
                              <v-list-item-avatar class="mx-2 my-1" size="50">
                                <v-img :src="require(`../assets/images/bank/${item.bankCode}.jpg`)" max-width="50"
                                  max-height="50" />
                              </v-list-item-avatar>
                              <span class="ms-3 bank-name">{{ item.accountName }} {{ item.accountNumber }}
                                <br />
                                <span class="bank-branch">{{ $t('payment.branch') }} : {{ item.accountBranch }}</span>
                              </span>
                            </template>
                            <template v-slot:item="{ item }">
                              <template>
                                <v-list-item-avatar class="mx-2 my-1" size="45">
                                  <v-img :src="require(`../assets/images/bank/${item.bankCode}.jpg`)" max-width="45"
                                    max-height="45" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title class="ps-2">
                                    <span class="bank-name">{{ item.accountName }} {{ item.accountNumber }}
                                      <br />
                                      <span class="bank-branch">{{ $t('payment.branch') }} : {{ item.accountBranch }}</span>
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-select>
                        </v-col>

                        <v-col cols="12" v-if="formData.paymentMethod == 8">
                          <div>
                            <v-text-field v-model="formData.voucherNumber"
                              type="input"
                              class="input-disable-appearance input-bg-white"
                              :placeholder="$t('payment.gift_voucher_or_other_code')"
                              outlined
                              small
                              dense
                              hide-details="auto"/>
                          </div>
                        </v-col>

                        <v-col cols="12" v-if="formData.paymentMethod == 2 || formData.paymentMethod == 8">
                          <v-row class="mb-2" no-gutters justify="center" v-if="tempFiles.length">
                            <template v-for="(file, index) in tempFiles">
                              <v-col :key="index" cols="6" class="px-2">
                                <v-card>
                                  <v-img :src="file.url ? file.url : fileToUrl(file)">
                                    <v-app-bar flat color="rgba(0, 0, 0, 0)">
                                      <v-spacer></v-spacer>
                                      <v-btn style="margin: -25px -15px 0 0" class="error white--text" elevation="2" icon
                                        rounded small @click="removeFile(index)"><v-icon>mdi-close</v-icon></v-btn>
                                    </v-app-bar>
                                  </v-img>
                                </v-card>
                              </v-col>
                            </template>
                          </v-row>
                          <div class="box-upload">
                            <div style="height: fit-content;">
                              <div class="btn-upload" @click="openFileDialog()">
                                Upload <v-icon class="text-upload">mdi-upload</v-icon>
                              </div>
                              <div>Files supported: PNG, JPEG</div>
                            </div>
                          </div>
                          <input ref="uploader" class="input-center d-none" :placeholder="$t('attach_proof')" outlined hide-details
                            clear-icon prepend-icon="" type="file" accept="image/*" @input="onUploadImage($event)" />
                        </v-col>

                        <v-col cols="12" v-if="formData.paymentMethod != 7">
                          <div class="text-sub-header">
                            {{ $t('note') }}
                          </div>
                          <v-textarea v-model="formData.paymentNote" class="input-center mt-3" :placeholder="$t('note')"
                            outlined hide-details rows="3" no-resize></v-textarea>
                        </v-col>
                      </v-row>

                      <v-row v-if="formData.paymentMethod == 7">
                        <v-col cols="12" v-if="isQrLoading">
                          <div class="d-flex justify-center my-4">
                            <v-progress-circular indeterminate color="green" size="50"></v-progress-circular>
                          </div>
                        </v-col>
                        <template v-if="!isQrLoading">
                          <template v-if="!isStatus && qrPaymentData">
                            <v-col cols="12">
                              <div>
                                <v-alert border="left" color="warning" text dense class="mt-2" style="font-size: 13px;">
                                  <div class="d-flex align-center">
                                    <div class="me-2">
                                      <v-icon color="warning">mdi-alert-circle</v-icon>
                                    </div>
                                    <div>
                                      {{ $t('validate.please_do_not_close_this_page_after_payment') }} <br />
                                      {{ $t('validate.system_will_update_automatically_after_payment') }}
                                    </div>
                                  </div>
                                </v-alert>
                              </div>
                              <div class="text-center">
                                <div>{{ $t('qr_payment.reference_number') }} : {{ qrPaymentData.partnerTxnUid }}</div>
                                <template v-if="isExpired">
                                  <h1 class="error--text font-weight-bold" style="font-size: 24px;">00:00</h1>
                                  <div class="error--text d-flex align-center justify-center" style="font-size: 13px;">QR
                                    Code {{ $t('expired') }}...</div>
                                </template>
                                <template v-else>
                                  <h1 class="success--text font-weight-bold" style="font-size: 24px;">{{ qrDuration }}</h1>
                                  <div class="success--text d-flex align-center justify-center" style="font-size: 13px;">
                                    <v-progress-circular indeterminate color="success" :width="2" :size="18" class="me-2" />
                                    {{ $t('checking') }}...
                                  </div>
                                </template>
                              </div>
                            </v-col>
  
                            <v-col cols="12">
                              <div class="d-flex justify-center">
                                <div id="thai-qr-code">
                                  <div class="box-qr">
                                    <div class="box-qr-expired" v-if="isExpired">
                                      <div>
                                        <v-btn color="warning" @click="initQrPayment()">
                                          <v-icon left>mdi-refresh</v-icon>
                                          {{ $t('qr_payment.click_to_receive_new_qr_code') }}
                                        </v-btn>
                                      </div>
                                    </div>
                                    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 373"
                                      width="100%">
                                      <title>ThaiQR-download-th</title>
                                      <g id="Layer 1">
                                        <path id="&lt;Path&gt;" fill="#1a3763" d="m0 0h1024v200h-1024z" />
                                        <path id="&lt;Path&gt; copy" fill="#ffffff" d="m0 198h1024v178h-1024z" />
                                        <g id="&lt;Group&gt;">
                                          <g id="&lt;Group&gt;">
                                            <g id="&lt;Group&gt;">
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m614 117.4c0 2.3 0 5.6 0 7.8q6.9 0 13.8 0c0 2 0 3.9 0 5.8q-6.8 0-13.8 0c0 2.8 0 4.4 0 7.1q7.7 0 15.5 0c0 2.1 0 4.1 0 6.1q-11.1 0-22.2 0 0-16.4 0-32.9 10.7 0 21.4 0 0 3 0 6.1-7.3 0-14.7 0z" />
                                              <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#fffefe"
                                                d="m534.8 144.2q-0.3 0-0.4 0-3.2 0-6.3 0c-0.3 0-0.5 0-0.6-0.3q-1.1-3.4-2.3-6.9c-0.1-0.2-0.2-0.3-0.5-0.3q-5.8 0-11.5 0c-0.3 0-0.4 0.1-0.5 0.4q-1.2 3.3-2.4 6.7-0.1 0.2-0.2 0.4-3.3 0-6.6 0 0.5-1.3 1-2.7 5.8-14.9 11.5-29.8c0.2-0.3 0.3-0.4 0.6-0.4q2.6 0 5.1 0c0.2 0 0.4 0.1 0.5 0.3q6.2 16.2 12.4 32.3 0.1 0.1 0.2 0.3zm-15.8-24.5q-0.1 0-0.1 0-2 5.7-4.1 11.4c2.8 0 5.5 0 8.2 0q-2-5.7-4-11.4z" />
                                              <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#fffefe"
                                                d="m481.9 111.3q0.2 0 0.3 0c4.4 0 8.9 0 13.3 0 2.7 0.1 5.2 0.9 7.4 2.7 1.6 1.5 2.6 3.3 2.9 5.4 0.3 2 0.2 4-0.5 5.9-0.9 2.5-2.8 4.2-5.3 5.2-1.6 0.7-3.3 0.9-5.1 0.9q-3.2 0.1-6.3 0.1-0.2 0-0.4 0c0 3.9 0 8.8 0 12.7-2.1 0-4.2 0-6.3 0 0-10.6 0-22.3 0-32.9zm6.3 14.4q0.1 0 0.2 0c2.1 0 4.1 0.1 6.2 0 0.7 0 1.4-0.2 2.1-0.3 1.3-0.4 2.2-1.2 2.6-2.5q0.3-1.5 0-2.9-0.4-1.5-1.8-2.1c-0.8-0.4-1.6-0.6-2.4-0.6q-3.4-0.1-6.7-0.1-0.1 0-0.2 0 0 4.3 0 8.5z" />
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m549.1 144.2c-2.1 0-4.2 0-6.3 0q0-0.2 0-0.4 0-6.5 0-13.1c0-0.2-0.1-0.5-0.2-0.7q-5.7-9.1-11.3-18.2-0.1-0.2-0.3-0.5 0.3 0 0.4 0 3.2 0 6.4 0c0.3 0 0.4 0.1 0.6 0.3q3.7 6.2 7.3 12.4 0.1 0.2 0.3 0.4 0.1-0.2 0.2-0.4 3.7-6.2 7.4-12.3c0.2-0.3 0.4-0.4 0.7-0.4q3.1 0 6.1 0c0.2 0 0.3 0 0.5 0-0.1 0.2-0.2 0.3-0.3 0.5q-5.6 9.1-11.3 18.2c-0.1 0.2-0.2 0.5-0.2 0.8q0 6.5 0 13 0 0.2 0 0.4z" />
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m692.9 117.4c-2.8 0-7.3 0-10.1 0q0 13.4 0 26.8c-2.1 0-4.2 0-6.3 0q0-13.3 0-26.8c-2.9 0-7.3 0-10.2 0 0-2 0-4 0-6.1 7.8 0 18.9 0 26.6 0 0 2 0 4 0 6.1z" />
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m594.1 111.3h-3.4l-8.4 23.2-8.9-23.2h-2-6.3v7.3 25.6h6.3v-23.2l7.7 20.7h5.8l7.8-19.4v21.9h6.3v-25.6-7.3z" />
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m656.3 111.3v23.5l-14.4-23.5h-5.8v32.9h5.8v-22.2l14.4 22.2h5.7v-32.9z" />
                                            </g>
                                            <g id="&lt;Group&gt;">
                                              <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#fffefe"
                                                d="m682.9 83.6c3.3 5.2 6.7 10.5 10 15.8-0.2 0-0.3 0-0.5 0q-3.6 0-7.3 0c-0.3 0-0.5-0.1-0.6-0.4q-4.3-7.1-8.5-14.2c-0.2-0.3-0.4-0.4-0.7-0.4q-1.9 0.1-3.8 0.1c0 4.9 0 9.9 0 14.8-2.5 0-4.9 0-7.3 0q0-19 0-38 0.2-0.1 0.3-0.1c5.1 0.1 10.3 0 15.4 0.1 2.9 0 5.7 0.8 8.1 2.6 2.4 1.8 3.6 4.3 3.9 7.3 0.2 2.2 0 4.3-0.9 6.4-1.3 2.7-3.4 4.4-6.2 5.4-0.6 0.2-1.2 0.4-1.9 0.6zm-11.4-5.9q0.2 0 0.4 0 3.3 0 6.7 0 0.9 0 1.8-0.2c2.7-0.3 4.1-2.1 4-4.8-0.1-1.7-0.8-3.1-2.4-3.8-0.7-0.3-1.6-0.5-2.3-0.5-2.7-0.1-5.3-0.1-8-0.1q-0.1 0-0.2 0.1c0 3.1 0 6.1 0 9.3z" />
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m547.3 99.4c-2.4 0-4.8 0-7.2 0 0-5.6 0-10 0-15.6-5.7 0-10.1 0-15.7 0 0 5.6 0 10 0 15.5-2.5 0-4.9 0-7.3 0q0-19 0-38 3.6 0 7.2 0c0 4.7 0 10.6 0 15.4 5.7 0 10.1 0 15.7 0 0-4.8 0-10.7 0-15.4 2.5 0 4.9 0 7.3 0q0 19 0 38.1z" />
                                              <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#fffefe"
                                                d="m589.2 99.4q-3 0-6 0-0.9 0-1.8 0c-0.3 0-0.4-0.1-0.5-0.4q-1.4-4-2.8-7.9c-0.1-0.4-0.3-0.5-0.7-0.5q-6.6 0.1-13.2 0c-0.3 0-0.5 0.1-0.6 0.5q-1.4 3.9-2.8 7.8-0.1 0.2-0.2 0.5-3.8 0-7.7 0 0.1-0.3 0.2-0.5 7.2-18.6 14.4-37.2c0.1-0.3 0.3-0.5 0.6-0.5q3 0.1 5.9 0c0.3 0 0.5 0.1 0.6 0.4q7.2 18.7 14.5 37.3c0 0.2 0.1 0.3 0.1 0.5zm-23.2-15.2c3.3 0 6.4 0 9.6 0-1.6-4.4-3.2-8.9-4.8-13.4-1.6 4.6-3.2 9-4.8 13.4z" />
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m492.9 68.3c-3.3 0-7.7 0-11 0 0-2.3 0-4.7 0-7 9 0 20.3 0 29.3 0 0 2.3 0 4.6 0 7-3.3 0-7.7 0-11 0 0 10.4 0 20.7 0 31-2.5 0-4.9 0-7.3 0q0-15.4 0-31z" />
                                              <path id="&lt;Path&gt;" fill="#fffefe"
                                                d="m593.7 61.3q3.6 0 7.2 0 0 19 0 38-3.6 0-7.2 0 0-19 0-38z" />
                                              <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#fffefe"
                                                d="m654 102.9l-6.1-6q-0.1 0.1-0.2 0.2-4.4 2.2-9.4 2.2-5.4 0-9.7-2.5-4.3-2.5-6.5-6.8-2.3-4.4-2.3-9.2 0-9.2 5.2-14.4 5.2-5.2 13.3-5.2 5.4 0 9.7 2.5 4.3 2.4 6.5 6.8 2.3 4.3 2.3 9.9 0 5.6-2.4 10-0.8 1.5-1.9 2.8l5.7 5.6zm-10.6-10.5l-5.1-5.1 4.2-4.2 5.7 5.8q0.5-0.7 0.9-1.4c1.1-2.1 1.7-4.4 1.7-7.2 0-2.8-0.6-5.1-1.6-7.2-1-1.8-2.4-3.3-4.2-4.3-2-1.1-4.2-1.7-6.7-1.7-3.9 0-6.7 1.1-9.1 3.4-2.3 2.4-3.4 5.7-3.4 10.2 0 2.3 0.5 4.5 1.6 6.5 0.9 1.9 2.3 3.4 4.2 4.5 1.9 1.1 4.1 1.6 6.7 1.6q2.7 0 5.1-0.9z" />
                                            </g>
                                          </g>
                                          <g id="&lt;Group&gt;">
                                            <g id="&lt;Group&gt;">
                                              <g id="&lt;Group&gt;">
                                                <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#ffffff"
                                                  d="m358.1 48.1c1.7 0 3.4-0.2 5.1 0q22.6 0 45.2 0c6.8 0 13.8 1.5 19.4 5.4 4.7 3.3 8 8.4 9.8 13.8 1.1 3.3 1.7 6.8 1.8 10.3-0.1 15 0 29.9-0.1 44.8q16.4 15.7 32.7 31.5c0.4 0.3 0.9 0.8 0.7 1.4-0.2 0.5-0.9 0.5-1.4 0.6q-54 0-108.1 0c-6.3 0-12.8-0.9-18.5-3.9-3.3-1.7-6.3-4.1-8.5-7-3.8-5-5.7-11.1-6.1-17.2-0.2-1.6-0.1-3.1-0.1-4.6q0-25 0-50.1c0.2-5.1 1.6-10.3 4.8-14.4 3.2-4.2 7.9-6.9 12.8-8.5 3.4-1.2 6.9-1.8 10.5-2.1zm-6.3 13.9c-2.4 0.8-4.6 2.3-6 4.4-1.4 2.2-2 4.8-2 7.4q0 10.9 0 21.8 9.6 0 19.1 0 0-5.2 0-10.4c0-1.7 0.7-3.5 2.1-4.5 1.5-1 3.3-1.3 5-1.3q4.4 0.1 8.7 0c0-6 0-12.1 0-18.2-6.6 0-13.1 0-19.7 0-2.4-0.2-4.9 0-7.2 0.8zm39.7-0.8c0 6.1 0 12.2 0 18.2q4.6 0.1 9.2 0c1.6 0.1 3.4 0.4 4.7 1.5 1.3 1 1.9 2.7 1.9 4.3 0 3.5 0 6.9 0 10.4q9.5 0 19.1 0 0-11.1 0-22.2c0-1.7-0.3-3.5-0.9-5.1-0.9-2.4-2.6-4.3-4.8-5.5-2.9-1.5-6.3-1.9-9.5-1.6q-9.8 0-19.7 0zm-47.7 47.1q0 11.5 0 23c0.1 1.8 0.5 3.6 1.3 5.3 1.1 1.9 2.9 3.5 4.9 4.4 2.9 1.4 6.2 1.8 9.3 1.6q9.7 0 19.4 0 0-9.1 0-18.2-4.6 0-9.2 0c-1.6 0-3.4-0.4-4.7-1.4-1.3-1-1.9-2.7-1.9-4.3q0-5.2 0-10.4-9.5-0.1-19.1 0zm63.5 0.7q0 4.9 0 9.8c0 1.4-0.3 2.9-1.3 3.9-1.1 1.2-2.7 1.7-4.2 1.7-3.6-0.1-7.1 0-10.7-0.1 0 0.8 0 1.6 0 2.4 0 5.2 0 10.5 0 15.7 1.5 0 3 0 4.5 0 15.1 0 30.1 0 45.2 0-6.5-6.5-13-13-19.5-19.5-4.7-4.6-9.3-9.3-14-13.9z" />
                                              </g>
                                            </g>
                                            <g id="&lt;Group&gt;">
                                              <path id="&lt;Path&gt;" fill="#54a69a"
                                                d="m407.3 109c4.7 4.6 9.3 9.3 14 13.9 6.5 6.5 13 13 19.5 19.5-15.1 0-30.1 0-45.2 0-1.5 0-3 0-4.5 0 0-5.2 0-10.5 0-15.7 0-0.8 0-1.6 0-2.4 3.6 0.1 7.1 0 10.7 0.1 1.5 0 3.1-0.5 4.2-1.7 1-1 1.3-2.5 1.3-3.9q0-4.9 0-9.8z" />
                                            </g>
                                          </g>
                                        </g>
                                        <g id="Layer 1">
                                          <path id="&lt;Path&gt;" fill="#003d69" d="m413 263.3h121.7v33.9h-121.7z" />
                                          <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                            d="m400 243h223.2v75h-223.2zm2.4 72.5h218.3v-70.1h-218.3z" />
                                          <g id="&lt;Group&gt;">
                                            <g id="&lt;Group&gt;">
                                              <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                                d="m537.4 263.4q7.7 0 15.4 0c2.6 0 5.3 0.6 7.4 2.2 1.5 1.1 2.6 2.8 3.1 4.6 0.5 2 0.5 4.2 0.3 6.3-0.2 1.9-0.8 4-2.2 5.5-1.6 1.6-3.8 2.4-6 2.8-2 0.4-3.9 0.2-5.9 0.3q-2.4 0-4.8 0 0 6 0 12.1-3.6 0-7.3 0 0-16.9 0-33.8zm7.3 5.9q0 4.9 0 9.9 3.2 0 6.4 0c1.4 0 3-0.3 4.1-1.3 1-0.9 1.3-2.3 1.3-3.6 0-1.2-0.2-2.6-1-3.5-1-1.1-2.4-1.5-3.8-1.5q-3.5 0-7 0z" />
                                            </g>
                                            <g id="&lt;Group&gt;">
                                              <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                                d="m572 268.1c1.9-0.6 3.8-0.9 5.7-0.8 2.1-0.1 4.3 0.3 6.3 1 1.1 0.4 2.1 0.9 2.9 1.8 1.3 1.3 1.6 3.2 1.7 5q0 6.1 0 12.2c0 1.1-0.1 2.3 0.2 3.4 0.1 0.6 0.7 0.9 1.2 1.2q0 0.5 0 1-3.7 0-7.4 0c-0.4-0.9-0.5-1.9-0.6-2.9-1.2 1.3-2.7 2.3-4.3 3-2.3 0.9-4.9 0.9-7.2 0.1-1.8-0.6-3.4-1.8-4.2-3.6-0.7-1.8-0.7-3.9-0.3-5.7 0.5-2 2-3.7 3.8-4.5 2.7-1.2 5.7-1.3 8.6-1.7 1-0.2 2.1-0.4 2.9-1.1 0.7-0.7 0.6-1.9 0.1-2.7-0.5-0.8-1.4-1-2.3-1.1-1.4-0.2-2.9-0.3-4.2 0.3-1.1 0.6-1.6 1.8-1.8 3q-3.3 0-6.6 0c0.2-1.8 0.6-3.6 1.7-5.1 0.9-1.3 2.3-2.3 3.8-2.8zm2.3 14.8c-0.9 0.4-1.6 1.2-1.8 2.3-0.1 1 0.1 2.3 1.1 3 1.1 0.9 2.7 0.8 4.1 0.5 1.3-0.4 2.8-1.2 3.5-2.5 0.8-1.7 0.5-3.6 0.6-5.4-2.3 1.3-5.1 1-7.5 2.1z" />
                                            </g>
                                            <path id="&lt;Path&gt;" fill="#003d69"
                                              d="m590.6 267.3q3.7 0 7.4 0 1.5 4.6 2.9 9.3 1.3-4.7 2.6-9.3 3.5 0 7 0c-2.7 10-5.4 19.9-8.1 29.9q-3.5 0-7.1 0 1.1-4 2.2-7.9-3.5-11-6.9-22z" />
                                          </g>
                                          <g id="&lt;Group&gt;">
                                            <path id="&lt;Path&gt;" fill="#ffffff"
                                              d="m436.5 269.8c-1.4-1.4-3.4-2.1-5.4-2.2q-6 0-12 0 0 1.4 0 2.8 5.4 0 10.7 0c1.3 0.1 2.6 0.2 3.5 1 0.9 0.7 1.3 1.9 1.3 3.1 0 1-0.2 2.2-1.1 3-0.9 0.8-2.3 1.1-3.5 1.2q-3.7 0-7.4 0 0-3.2 0-6.4-1.7 0-3.5 0 0 9.7 0 19.4 1.8 0 3.5 0 0-5.1 0-10.2 4.2 0 8.3 0c1.7-0.1 3.4-0.4 4.8-1.5 1.7-1.6 2.6-4 2.4-6.3-0.2-1.4-0.7-2.8-1.6-3.9z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#ffffff"
                                              d="m466.9 278.2c0.8 1.7 0.9 3.6 0.8 5.4-0.2 2.5-1 4.9-2.8 6.6-1.7 1.6-4 2.1-6.3 2.1-2 0-4.2-0.7-5.6-2.3-1.6-1.5-2.3-3.7-2.5-5.9-0.1-2.5 0.3-5.2 1.9-7.3 1.1-1.5 2.9-2.6 4.8-3 2.1-0.4 4.4-0.2 6.3 0.8 1.5 0.8 2.8 2.1 3.4 3.6zm-2.6 2.7c-0.1-1.3-0.6-2.7-1.7-3.6-1.2-1-2.8-1.2-4.4-1-1.1 0.1-2.3 0.7-3 1.7-1.1 1.6-1.5 3.7-1.5 5.6 0.1 1.8 0.6 3.6 1.8 4.8 1.2 1.3 3.2 1.5 4.8 1.2 1.2-0.1 2.2-0.8 2.8-1.8 1.2-2 1.5-4.5 1.2-6.9z" />
                                            <path id="&lt;Path&gt;" fill="#ffffff"
                                              d="m449.1 273.8c-1-0.1-2-0.1-2.9 0.3-1.3 0.6-2.4 1.7-3.2 2.9q0-1.4 0-2.9-1.5 0-3 0 0 8.8 0 17.6 1.6 0 3.2 0 0-5.1 0-10.2c0-1.5 0.7-2.9 1.9-3.8 1.1-0.8 2.6-1 4-0.8 0-1 0-2.1 0-3.1z" />
                                            <path id="&lt;Path&gt;" fill="#ffffff"
                                              d="m527.7 289.3c-0.7 0.1-1.4 0.1-2.1 0-0.5-0.1-0.9-0.7-0.9-1.2q0-5.8 0-11.6 1.5 0 3 0 0-1.2 0-2.4-1.5 0-3 0 0-2.4 0-4.9-1.6 0-3.2 0 0 2.5 0 4.9-1.2 0-2.4 0 0 1.2 0 2.4 1.2 0 2.4 0 0 5.6 0 11.1c0.1 1.1 0.1 2.2 0.7 3.1 0.5 0.8 1.4 1.1 2.2 1.2 1.1 0.1 2.2 0 3.3-0.3q0-1.1 0-2.3z" />
                                            <path id="&lt;Path&gt;" fill="#ffffff"
                                              d="m494.9 275c-1.4-1.2-3.5-1.4-5.3-1.2-1.8 0.2-3.4 1.2-4.5 2.7-0.4-0.8-1-1.6-1.8-2.1-1.4-0.7-3.1-0.8-4.6-0.5-1.7 0.3-3 1.4-4.1 2.7q0-1.2 0-2.5-1.5 0-3 0 0 8.8 0 17.6 1.5 0 3.1 0 0-4.7 0-9.3c0-1 0.1-2.1 0.4-3.1 0.7-2.2 3.5-3.5 5.7-2.7 0.6 0.2 1.2 0.7 1.4 1.4 0.3 0.9 0.3 1.9 0.3 2.9q0 5.4 0 10.8 1.6 0 3.2 0 0-5.3 0-10.5c0-1.1 0.2-2.3 0.9-3.2 1.4-1.6 3.8-2.1 5.6-1 0.9 0.5 1.1 1.6 1.1 2.5 0.1 4 0 8.1 0 12.2q1.7 0 3.3 0 0-6.1 0-12.2c-0.1-1.6-0.4-3.3-1.7-4.5z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#ffffff"
                                              d="m516 288.5c-1.1 2-3.2 3.4-5.4 3.7-1.5 0.1-3.1 0-4.5-0.7-0.8-0.4-1.5-1.1-2.1-1.8q0 2.7 0 5.4-1.5 0-3.1 0 0-10.4 0-20.9 1.5 0 3.1 0 0 1.1 0 2.2c1.1-1.3 2.5-2.3 4.2-2.6 2.3-0.4 4.8 0.2 6.5 1.8 1.7 1.4 2.5 3.7 2.6 5.9 0.1 2.4-0.1 4.9-1.3 7zm-2-7.4c-0.2-1.4-0.8-2.9-1.9-3.8-1.1-1-2.7-1.2-4.1-0.9-1.3 0.2-2.4 1-3 2-1 1.7-1.1 3.7-1.1 5.6 0.1 1.5 0.5 3.2 1.6 4.3 1.1 1.2 2.9 1.5 4.4 1.3 1.7-0.3 3-1.6 3.6-3.1 0.7-1.7 0.7-3.6 0.5-5.4z" />
                                          </g>
                                          <g id="&lt;Group&gt;">
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m547.1 259.2c0 0.4-0.1 0.9-0.6 1.1-0.6 0.2-1.2 0.1-1.8 0.1-0.5-1.8-1.1-3.5-1.6-5.2q-0.9 2.6-1.8 5.2c-0.5 0-1.1 0-1.5-0.1-0.5-0.1-0.7-0.6-0.7-1q0-1.9 0-3.8c-0.6 0-1.2-0.2-1.6-0.7-0.5-0.5-0.5-1.4 0-1.8 0.8-0.8 2.2-0.8 3-0.1 0.6 0.5 0.4 1.4 0.5 2.1 0 0.9-0.2 1.9-0.2 2.8 0.3-1.9 1.1-3.6 1.6-5.4q0.7 0 1.4 0c0.5 1.8 1.3 3.6 1.6 5.4-0.2-1.8-0.2-3.6-0.2-5.4q1 0 1.9 0 0 3.4 0 6.8zm-7.6-5.3c0-0.3-0.2-0.5-0.5-0.5-0.3 0-0.6 0.2-0.6 0.5 0 0.3 0.3 0.6 0.6 0.6 0.3 0 0.5-0.3 0.5-0.6z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m553.1 253.6c-0.4 0-0.6 0.2-0.9 0.5 1.2 0.1 2.5 0.1 3.6 0.7 0.5 0.3 0.8 0.9 0.7 1.4 0 1 0.1 2 0 2.9-0.1 1-1.1 1.5-1.9 1.4-1 0.1-2-0.7-1.9-1.7 0.1-0.9 1.1-1.4 2-1.4-0.1-0.6 0.3-1.4-0.4-1.8-1.4-0.5-2.9-0.3-4.3-0.4 0.2-1 0.6-2 1.5-2.5 1-0.6 2.3-0.5 3.4-0.1 0.5 0.2 0.9-0.1 1.2-0.4q0.7 0.5 1.4 0.9c-0.4 0.5-0.9 0.9-1.5 1-1 0.2-1.9-0.7-2.9-0.5zm1.9 5.3c0-0.3-0.2-0.5-0.5-0.5-0.3 0-0.5 0.2-0.5 0.5 0 0.3 0.2 0.6 0.5 0.6 0.3 0 0.5-0.3 0.5-0.6z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m567.8 258.7c0 0.5-0.2 1.1-0.8 1.4-0.6 0.3-1.4 0.3-2.2 0.3q-1.9 0-3.9 0c0-1.4 0-2.8 0-4.1 0.1-0.9 1.1-1.4 1.9-1.4 1 0 2.1 0.8 1.9 1.8-0.1 0.9-1.2 1.4-2 1.3q0 0.5 0 1.1c0.9 0 1.7 0 2.6-0.1 0.4 0 0.7-0.4 0.7-0.8q0-1.6 0-3.2c0-0.5-0.3-1-0.7-1.2-1.2-0.6-2.8-0.2-3.3 1.1q-1 0-1.9 0c0.3-1.4 1.6-2.4 2.9-2.6 1.2-0.1 2.4-0.1 3.5 0.4 0.7 0.4 1.3 1.1 1.3 1.9q0 2 0 4.1zm-4.3-2.2c0-0.3-0.3-0.5-0.6-0.5-0.3 0-0.5 0.2-0.5 0.5 0 0.3 0.2 0.6 0.5 0.6 0.3 0 0.6-0.3 0.6-0.6z" />
                                            <path id="&lt;Path&gt;" fill="#003d69"
                                              d="m573.2 254.5c-0.3 0-0.6-0.3-0.6-0.6 0-0.3 0.3-0.5 0.6-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.6-0.5 0.6z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m587.2 260.1c-0.8 0.6-2 0.6-2.8 0-0.4-0.3-0.5-0.9-0.5-1.4q0-3.1 0-6.3 0.9 0 1.8 0 0 2.5 0 5c0.8 0 1.6 0.3 1.9 1.1 0.3 0.5 0 1.2-0.4 1.6zm-0.8-1.2c0-0.3-0.2-0.5-0.5-0.5-0.3 0-0.6 0.2-0.6 0.5 0 0.3 0.3 0.6 0.6 0.6 0.3 0 0.5-0.3 0.5-0.6z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m600.2 259.2c0 0.4-0.1 0.9-0.6 1.1-0.6 0.2-1.2 0.1-1.8 0.1-0.5-1.8-1.1-3.5-1.6-5.2q-0.9 2.6-1.8 5.2c-0.5 0-1 0-1.5-0.1-0.5-0.1-0.7-0.6-0.7-1q0-1.9 0-3.8c-0.6 0-1.2-0.2-1.6-0.7-0.5-0.4-0.5-1.3 0-1.8 0.7-0.8 2.1-0.8 2.9-0.2 0.7 0.5 0.6 1.5 0.6 2.2 0 0.9-0.2 1.9-0.1 2.8 0.2-1.9 1-3.6 1.5-5.4q0.7 0 1.4 0c0.5 1.8 1.3 3.6 1.6 5.4-0.2-1.8-0.1-3.6-0.1-5.4q0.9 0 1.8 0 0 3.4 0 6.8zm-7.6-5.3c0-0.3-0.2-0.5-0.5-0.5-0.3 0-0.6 0.2-0.6 0.5 0 0.3 0.3 0.6 0.6 0.6 0.3 0 0.5-0.3 0.5-0.6z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m610.6 252.4q0 3 0 6c0 0.5-0.1 1.1-0.5 1.5-0.5 0.4-1.1 0.5-1.6 0.5q-2.4 0-4.9 0 0-1.4 0-2.8c0-0.5 0.5-1 1-1.1-0.6-0.1-1.3-0.5-1.2-1.2 0.1-0.8-0.2-1.7 0.4-2.3 0.6-0.7 1.5-0.7 2.3-0.5 0.9 0.2 1.4 1.2 1 1.9-0.3 0.7-1 1-1.7 1 0.5 0.5 1.3 0.2 2 0.3q0 0.7 0 1.3c-0.6 0.1-1.4-0.2-1.8 0.3-0.3 0.6-0.1 1.1-0.2 1.7 0.9 0 1.8 0 2.6 0 0.4 0 0.8-0.4 0.8-0.7q0-3 0-5.9 0.9 0 1.8 0zm-4.6 1.5c0-0.3-0.3-0.5-0.6-0.5-0.3 0-0.5 0.2-0.5 0.5 0 0.3 0.2 0.6 0.5 0.6 0.3 0 0.6-0.3 0.6-0.6z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m610 249.3c0.3 0.3 0.5 0.8 0.3 1.3-0.5 1.2-2.4 1.2-3.1 0.1-0.4-0.6-0.1-1.5 0.5-1.9 0.6-0.5 1.3-0.5 2-0.7 0.4-0.1 0.6-0.5 0.8-0.9q0.7 0.2 1.4 0.5c-0.1 1-1.1 1.4-1.9 1.6zm-0.8 0.9c0-0.3-0.2-0.5-0.5-0.5-0.2 0-0.4 0.2-0.4 0.5 0 0.2 0.2 0.4 0.4 0.4 0.3 0 0.5-0.2 0.5-0.4z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m558 248c-0.2 1-0.8 1.8-1.6 2.4-0.9 0.6-2 0.9-3.1 1.1-0.5 0.1-0.9-0.3-1.3-0.5q0.5-0.3 0.9-0.8c-0.5 0-0.9-0.2-1.2-0.6-0.4-0.7 0-1.6 0.7-1.8 0.8-0.3 1.8-0.2 2.3 0.5 0.3 0.5 0.2 1.1 0 1.6 0.8-0.4 1.5-1 1.7-1.9q0.8 0 1.6 0zm-4.4 1c0-0.3-0.2-0.5-0.4-0.5-0.3 0-0.5 0.2-0.5 0.5 0 0.2 0.2 0.4 0.5 0.4 0.2 0 0.4-0.2 0.4-0.4z" />
                                            <path id="&lt;Compound Path&gt;" fill-rule="evenodd" fill="#003d69"
                                              d="m579.5 252.4q0 3.3 0 6.6c0 0.4 0 0.9-0.4 1.1-0.5 0.4-1.1 0.3-1.6 0.3-0.5-1-1.3-1.8-2.3-2.2 0 0.6 0.1 1.3-0.4 1.7-1.1 0.9-3.3 0.5-3.5-1-0.2-1.2 1-2.1 2.1-2.1q0-0.7 0-1.4c-1 0.1-2.1-0.5-2.1-1.6 0.3-1.8 3.4-1.9 3.8-0.2 0.1 1.1 0 2.1 0.1 3.2 0.9 0.2 1.8 0.6 2.5 1.2q0-2.8 0-5.6 0.9 0 1.8 0zm-6.1 6.3v-0.6q0-0.1 0-0.1c-0.5 0.1-1 0.5-0.7 1q0 0 0 0c0.2 0.2 0.5 0.2 0.6 0.1 0.1-0.1 0.1-0.4 0.1-0.4z" />
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
  
                                    <div class="header-qr-code text-center">
                                      <div class="txt-title">{{ projectName }}</div>
                                      <div class="txt-sub">{{ marketName }}</div>
                                    </div>
                                    <div class="box-img-qr">
                                      <img class="qrcode" :src="qrCode" style="margin: 0 auto;" alt='qrcode' />
                                    </div>
                                    <div class="text-qr-detail my-2">
                                      <div class="d-flex justify-center">
                                        <div class="txt-title">{{ $t('payment.account_name') }} :&nbsp;</div>
                                        <div class="txt-title font-weight-bold" style="max-width: 150px;">{{
                                          qrPaymentData.accountName }}</div>
                                      </div>
                                      <div class="d-flex justify-center">
                                        <div class="txt-title">{{ $t('payment.amount') }} :&nbsp;</div>
                                        <div class="txt-title font-weight-bold">
                                          <span>{{ qrPaymentData.amount | currency }}</span>
                                          {{ currencyThEn }}
                                        </div>
                                      </div>
                                      <div class="txt-sub-title">
                                        {{ $t('qr_payment.reference_number') }} : {{ qrPaymentData.partnerTxnUid }}
                                      </div>
                                      <div class="txt-title-grey">
                                        {{ $t('payment.payment_within') }} : {{ $moment(expiredDateTime).format("D MMM YYYY, HH: mm") }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="12" class="px-6">
                              <v-row>
                                <v-col cols="6" class="px-2">
                                  <v-btn color="success" block elevation="0" small class="py-4" @click="saveQrCode()"
                                    :disabled="isExpired">
                                    <v-icon class="mr-2">mdi-download-outline</v-icon>
                                    {{ $t('qr_payment.save_qr_code') }}
                                  </v-btn>
                                </v-col>
                                <v-col cols="6" class="px-2">
                                  <v-btn color="info" block elevation="0" small class="py-4" @click="printQrCode()"
                                    :disabled="isExpired">
                                    <v-icon class="mr-2">mdi-printer-outline</v-icon>
                                    {{ $t('qr_payment.print_qr_code') }}
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>
                          </template>
                          <v-col cols="12" v-else>
                            <div style="text-align: center; width: 100%; margin-top: 30px;">
                              <template v-if="qrPaymentReport && qrPaymentReport.isReceiptPaid">
                                <div>
                                  <v-icon style="font-size: 60px;" color="success">mdi-check-circle</v-icon>
                                </div>
                                <div class="success--text" style="font-size: 20px;">{{ $t("qr_payment.success_paid") }}</div>
                              </template>
                              <template v-else>
                                <div>
                                  <v-icon style="font-size: 60px;" color="error">mdi-alert-circle</v-icon>
                                </div>
                                <div class="error--text" style="font-size: 20px;">{{ $t("error") }}</div>
                                <div v-if="qrPaymentReport && qrPaymentReport.result && qrPaymentReport.result.errorDesc">
                                  <div class="grey--text" style="font-size: 14px;">{{ $t("qr_payment.please_check_payment") }}</div>
                                  <div class="grey--text" style="font-size: 12px;">{{ qrPaymentReport.result.errorDesc }}</div>
                                </div>
                                <div v-if="qrPaymentData && qrPaymentData.errorDesc">
                                  <div class="grey--text" style="font-size: 12px;">{{ qrPaymentData.errorDesc }}</div>
                                </div>
                              </template>
                            </div>
                          </v-col>
                        </template>
                      </v-row>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="border-t">
            <v-spacer></v-spacer>
            <span v-if="paidValue < 0" class="me-3 red--text">{{ $t('validate.you_cannot_pay_less_than_zero') }} 0 {{ currencyThEn }}</span>
            <v-btn :disabled="isSaveing" @click="dismiss()" color="error" outlined>
              {{ $t('close') }}
            </v-btn>
            <v-btn type="submit" color="success" elevation="0" :disabled="isDisableSubmit">
              {{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="d-flex justify-space-between text-center py-10" elevation="1" v-else>
          <center>
            <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
          </center>
        </v-card>
      </v-form>
      <div style="display: none;">
        <iframe width="100%" height="500px" frameborder="0" name="iframe-qr-payment" id="iframe-qr-payment"></iframe>
      </div>
      <v-dialog v-model="isCancelQrDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="d-flex justify-center" style="font-size: 20px; font-weight: bold;">
            {{ $t('qr_payment.cancel_qr_code') }}
          </v-card-title>
          <v-card-text class="text-center py-10">
            {{ $t('validate.you_want_to_cancel_qr_code') }}
          </v-card-text>
          <v-card-actions class="px-0 border-t">
            <v-row no-gutters>
              <v-col cols="6" class="px-2 ps-3">
                <v-btn outlined block @click="isCancelQrDialog = false" :disabled="isCancelQrLoading" elevation="0">
                  {{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col cols="6" class="px-2 pe-3">
                <v-btn color="error" block @click="cancelQrPayment()" :disabled="isCancelQrLoading">
                  {{ $t('confirm') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
    <LoadingPercentDialog v-model="isLoadingPercentDialog" :final="loadingFinal" :initial="loadingInitial" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { FileUpload, Invoice } from "../classes";
import LoadingPercentDialog from "@/components/LoadingPercentDialog.component";
import QRCode from "qrcode"
import * as htmlToImage from 'html-to-image';
import { saveAs } from "file-saver";
import CurrencySelect from "@/components/CurrencySelect.vue";
export default {
  props: {
    value: Boolean,
    projectId: String,
    invoice: Object,
    receipt: Object,
    paymentMethod: Number,
    paymentProofFiles: Array,
    paymentBankAccount: Object,
    receipts: Array,
    order: Object,
    contractCheckout: Object,
    contractCheckouts: Array,
    isHideSplitPay: Boolean,
    dialogType: {
      type: String,
      default: "extra"
    },
  },
  components: {
    LoadingPercentDialog,
    CurrencySelect
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      isLoadingBankAccounts: false,
      isSaveing: false,
      formData: {
        date: this.$moment().format("YYYY-MM-DD"),
        paymentMethod: 1,
        paymentBankAccount: null,
        paymentNote: null,
        paymentProofFiles: [],
        voucherNumber: null,
        paymentType: "full",
        amount: null,
        splitType: "amount",
        paymentCurrencyCode: this.$globalCurrencyCode,
        exchangeRateType: "auto",
        exchangeRate: null,
        totalPaymentValue: null,
        manualExchangeRate: null,
        exchangeRateDate: this.$moment().format("YYYY-MM-DD"),
      },
      menuDate: false,
      tempFiles: [],
      tempBankAccountId: null,
      tempReceipt: null,
      dataTable: {
        headers: [
          {
            text: this.$t('list'),
            align: "left",
            value: "name"
          },
          {
            text: this.$t('tax.title'),
            align: "center",
            value: "vat"
          },
          {
            text: this.$t('price'),
            align: "right",
            value: "totalValue"
          },
        ],
        data: []
      },
      qrCode: null,
      qrPaymentData: null,
      qrDuration: "9:30",
      isStatus: false,
      qrPaymentReport: null,
      isExpired: false,
      durationInquiry: 30,
      isQrLoading: false,
      intervalQrTime: null,
      isSubmitFromQr: false,
      isCancelQrDialog: false,
      isCancelQrLoading: false,
      tempFormData: {
        paymentType: "full",
        splitType: "amount",
        paymentMethod: 1,
      },
      isLoadingPercentDialog: false,
      loadingFinal: 0,
      loadingInitial: 0,
      projectName: null,
      marketName: null,
      expiredDateTime: null,
      menuPaymentRate : false,
      menuPaymentRateDate: false,
      isLoadingCurrencyRate: false,
      selectedStalls: [],
      isUpdatingFromItems: false,
      isUpdatingFromStalls: false,
    };
  },
  computed: {
    ...mapState({
      bankAccounts: (state) => state.bankAccount.bankAccounts,
      currencyRate: (state) => state.currencyRate.currencyRate,
    }),
    rules() {
      let _max;
      if (this.invoice) {
        _max = this.invoice.totalValue

        if (this.invoice.totalPaidValue)
          _max = this.invoice.totalValue - this.invoice.totalPaidValue
      }
      return {
        required: (value) => !!value || this.$t('validate.please_input_data'),
        min: (value) => (value && value > 0) || `${this.$t('payment.pay_in_split_minimum')} ${this.currencyThEn}`,
        max: (value) => (value && value <= _max) || `${this.$t('payment.pay_in_split_not_exceed_no_space')} ${this.$helper.toCurrency(_max)} ${this.currencyThEn}`,
      }
    },
    isWht() {
      return this.invoice && this.invoice.totalWhtValue > 0 || this.receipt && this.receipt.totalWhtValue > 0 || this.order && this.order.totalWhtValue > 0
    },
    totalWhtValue() {
      if (this.invoice) return this.invoice.totalWhtValue
      else if (this.receipt) return this.receipt.totalWhtValue
      else if (this.order) return this.order.totalWhtValue
      else return 0
    },
    paidValue() {
      if (this.formData.paymentType == "split") {
        if (this.formData.splitType == "item" && this.tempReceipt) {
          return this.tempReceipt.totalValue
        } else {
          return this.formData.amount
        }
      } else {
        if (this.invoice) return this.invoice.totalUnpaidValue
        else if (this.order) return this.order.totalUnpaidValue
        else if (this.contractCheckout) return this.contractCheckout.totalCostAbs
        else return 0
      }
    },
    isQrPayment() {
      if(this.isQrLoading || this.qrPaymentData) return true
      else return false
    },
    isQRPaymentSetting() {
      if (this.invoice) return this.invoice.market.qrPaymentSetting
      else if (this.order) return this.order.market.qrPaymentSetting
      else if (this.contractCheckout) return this.contractCheckout.market.qrPaymentSetting
      else return false
    },
    paidValueWithWht() {
      let amount = this.paidValue
      if (this.isWht) amount = amount - this.totalWhtValue
      return amount
    },
    totalUnpaidValue() {
      if (this.invoice) return this.invoice.totalUnpaidValue - this.invoice.totalWhtValue
      else if (this.receipt) return this.receipt.totalValue - this.receipt.totalWhtValue
      else if (this.order) return this.order.totalValue - this.order.totalWhtValue
      else if (this.contractCheckout) return this.contractCheckout.totalCostAbs
      else if (this.contractCheckouts) return this.sumField(this.contractCheckouts, 'refundCost')
      else return 0
    },
    isDisableSubmit() {
      if (this.isSaveing || !this.value || this.paidValue < 0 || this.isQrPayment) {
        return true
      } else if (this.formData.paymentType == "split") {
        if (this.formData.splitType == "amount" && (this.formData.amount > this.totalUnpaidValue || !this.formData.amount)) return true
        else if (this.formData.splitType == "item" && (this.tempReceipt.totalValue > this.totalUnpaidValue || !this.tempReceipt.items.length)) return true
        else return false
      } else {
        return false
      }
    },
    currencyCode() {
      if (this.invoice?.currencyCode) return this.invoice.currencyCode
      else if (this.receipt?.currencyCode) return this.receipt.currencyCode
      else if (this.order?.currencyCode) return this.order.currencyCode
      else if (this.contractCheckout?.currencyCode) return this.contractCheckout.currencyCode
      else return this.$globalCurrencyCode
    },
    currencyThEn() {
      return this.$helper.currencyThEn(this.currencyCode)
    },
    calculateExchangeRate() {
      const actualAmount = parseFloat(this.formData.totalPaymentValue) || 0 
      const exchangeRate = parseFloat(this.formData.exchangeRate) || 0
      const requiredAmount = this.paidValue || 0
      
      const convertedAmount = this.$helper.round(actualAmount * exchangeRate)
      let profit = convertedAmount - requiredAmount
      
      if (this.dialogType == "refund") profit *= -1
      const baseCurrency = this.$helper.currencyThEn(this.formData.paymentCurrencyCode)
      const targetCurrency = this.$helper.currencyThEn(this.currencyCode)

      return {
        steps: [
          `1. ${this.$t('payment.calculation_step_1', { baseCurrency, targetCurrency })}`,
          `2. ${this.$t('payment.calculation_step_2', { targetCurrency })}`
        ],
        calculation: [
          `1. ${this.$helper.toCurrency(actualAmount)} ${baseCurrency} x ${exchangeRate} ${targetCurrency} ≈ ${this.$helper.toCurrency(convertedAmount)} ${targetCurrency}`,
          `2. ${this.$helper.toCurrency(convertedAmount)} ${targetCurrency} - ${this.$helper.toCurrency(requiredAmount)} ${targetCurrency} = ${this.$helper.toCurrency(profit)} ${targetCurrency}`
        ],
        profit: profit,
        result: this.$t('payment.exchange_profit_loss_result', { profit: this.$helper.toCurrency(profit), currency: targetCurrency })
      }
    },
    isDifferentCurrency() {
      if (!this.formData?.paymentCurrencyCode) return false
      return this.formData.paymentCurrencyCode != this.currencyCode
    },
    isContractCheckout() {
      return !!(this.contractCheckout || (this.contractCheckouts && this.contractCheckouts.length))
    },
    groupedStallData() {
      if (!this.dataTable.data?.length) return []
      return this.buildGroupedStallData(this.dataTable.data)
    },
    stallTotalValue() {
      if (!this.selectedStalls?.length) return 0
      const total = this.selectedStalls.reduce((sum, stall) => sum + stall.totalValue, 0)
      return parseFloat(total.toFixed(4))
    }
  },
  watch: {
    value(val) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.tempFiles = [];
      this.tempReceipt = null
      this.dataTable.data = []
      this.selectedStalls = []
      this.isUpdatingFromItems = false
      this.isUpdatingFromStalls = false
      this.formData = {
        date: this.$moment().format("YYYY-MM-DD"),
        paymentMethod: 1,
        paymentBankAccount: null,
        paymentNote: null,
        paymentProofFiles: [],
        voucherNumber: null,
        paymentType: "full",
        amount: null,
        splitType: "amount",
        isSplitVatNonVat: localStorage.getItem("isSplitVatNonVat") ? JSON.parse(localStorage.getItem("isSplitVatNonVat")) : false,
        paymentCurrencyCode: this.currencyCode,
        exchangeRateType: "auto",
        exchangeRate: null,
        totalPaymentValue: null,
        manualExchangeRate: null,
        exchangeRateDate: this.$moment().format("YYYY-MM-DD"),
      };
      this.qrCode = null
      this.qrPaymentData = null
      this.qrDuration = "9:30"
      this.isStatus = false
      this.qrPaymentReport = null
      this.isExpired = false
      this.expiredDateTime = null
      this.durationInquiry = 30
      this.isQrLoading = false
      if (this.intervalQrTime) clearInterval(this.intervalQrTime)

      if (this.paymentMethod) this.formData.paymentMethod = this.paymentMethod
      if (this.paymentProofFiles) this.tempFiles = this.paymentProofFiles

      let receiptItems = []
      if (this.receipts && this.receipts.length) {
        for (let receipt of this.receipts.filter(d => d.isPaid)) {
          for (let item of receipt.items) {
            receiptItems.push({
              area: item.area,
              name: item.name,
              totalValue: item.totalValue,
              isUsed: false
            })
          }
        }
      }

      if (this.invoice && this.invoice.items) {
        for (let [index, item] of this.invoice.items.entries()) {
          let receiptItem = receiptItems.find(d =>
            d.area?.objectId == item.area?.objectId &&
            d.name == item.name &&
            d.totalValue == item.totalValue &&
            !d.isUsed
          )
          if (receiptItem) {
            receiptItem.isUsed = true
          } else {
            item.id = index
            this.dataTable.data.push(item)
          }
        }
        this.tempReceipt = new Invoice({
          isVatInclusive: this.invoice.isVatInclusive,
          vatPercent: this.invoice.vatPercent,
          isVat: this.invoice.isVat
        })
        this.tempReceipt.items = []
      }
      if (this.receipt && this.receipt.date) {
        this.formData.date = this.$moment(this.receipt.date).format("YYYY-MM-DD")
      }
      this.initPaymentBankAccount()
      if (this.$helper.currencyOptions.length > 1) this.initCurrencyRate()
      if (val) this.initData()
    },
    paidValue() {
      this.calPaymentTotalValue()
    },
  },
  async created() {
    this.initBankAccounts()
  },
  methods: {
    async initData() {
      let market;
      let project;
      if (this.invoice) {
        market = this.invoice.market
        project = this.invoice.project
      } else if (this.receipt) {
        market = this.receipt.market
        project = this.receipt.project
      } else if (this.order) {
        market = this.order.market;
        project = this.order.project
      }
      else if (this.contractCheckout) {
        market = this.contractCheckout.market
        project = this.contractCheckout.project
      }
      if (market && market.qrPaymentSetting && (!this.paymentMethod || this.paymentMethod == 7)) {
        this.isLoading = true
        try {
          let lastQRPaymentReport = await this.$store.dispatch("qrPayment/qrPaymentLastRequest", {
            invoiceId: this.invoice?.objectId,
            contractCheckoutId: this.contractCheckout?.objectId,
            orderId: this.order?.objectId
          })
          this.isLoading = false
          if (lastQRPaymentReport) {
            let amount = this.paidValueWithWht
            if (this.isWht) {
              if (lastQRPaymentReport.amount == amount && !lastQRPaymentReport.items) {
                this.formData.amount = amount
                this.formData.paymentType = "full"
                this.formData.paymentMethod = 7
                await this.initQrPayment(lastQRPaymentReport)
              }
            } else {
              if (lastQRPaymentReport.amount <= amount) {
                if (lastQRPaymentReport.amount == amount) {
                  this.formData.paymentType = "full"
                  this.formData.paymentMethod = 7
                  await this.initQrPayment(lastQRPaymentReport)
                } else {
                  if (lastQRPaymentReport.items && lastQRPaymentReport.items.length) {
                    for (let item of lastQRPaymentReport.items) {
                      let _item = this.dataTable.data.find(d =>
                        d.accountingProduct?.objectId == item.accountingProduct?.objectId &&
                        d.area?.objectId == item.area?.objectId &&
                        d.billingSetting?.objectId == item.billingSetting?.objectId
                      )
                      this.tempReceipt.items.push(_item)
                    }
                    this.formData.amount = lastQRPaymentReport.amount
                    this.formData.paymentType = "split"
                    this.formData.splitType = "item"
                    this.formData.paymentMethod = 7
                    await this.initQrPayment(lastQRPaymentReport)
                  } else {
                    this.formData.amount = lastQRPaymentReport.amount
                    this.formData.paymentType = "split"
                    this.formData.splitType = "amount"
                    this.formData.paymentMethod = 7
                    await this.initQrPayment(lastQRPaymentReport)
                  }
                }
              }
            }
          }
        } catch (error) {
          this.isLoading = false
        }
      }
      if (project && project.name) this.projectName = project.name;
      if (market && market.name) this.marketName = market.name;
    },
    initPaymentBankAccount() {
      if (this.paymentBankAccount && this.bankAccounts) {
        let bankAccount;
        bankAccount = this.bankAccounts.find(
          d =>
            d.accountNumber == this.paymentBankAccount.accountNumber &&
            d.accountName == this.paymentBankAccount.accountName &&
            d.bankCode == this.paymentBankAccount.bankCode
        )
        if (bankAccount) {
          this.formData.paymentBankAccount = bankAccount.objectId
        } else if (this.paymentBankAccount) {
          let date = new Date()
          this.$store.commit("bankAccount/addBankAccounts", {
            objectId: date.getTime(),
            ...this.paymentBankAccount
          })
          this.formData.paymentBankAccount = date.getTime()
        }
      }
    },
    async initBankAccounts() {
      this.isLoadingBankAccounts = true;
      try {
        let projectId = this.projectId || this.$route.params.projectId
        await this.$store.dispatch(
          "bankAccount/getBankAccounts",
          projectId
        );
        this.isLoadingBankAccounts = false;
      } catch (error) {
        console.log(error)
        this.isLoadingBankAccounts = false;
        this.isError = true;
      }
    },
    async initCurrencyRate() {
      this.isLoadingCurrencyRate = true;
      try {
        let tempCurrencyRate = this.currencyRate
        let date = this.formData.exchangeRateDate || this.$moment().format("YYYY-MM-DD")
        let currencyRate = await this.$store.dispatch("currencyRate/getCurrencyRateByDate", {
          date: date
        })
        if (!currencyRate) {
          this.$store.commit("currencyRate/setCurrencyRate", tempCurrencyRate)
          this.$toast.show({
            content: this.$t('payment.not_found_currency_rate') + " " + this.$moment(date).format("DD MMM YYYY"),
            color: "warning"
          });
        }
        this.isLoadingCurrencyRate = false;
      } catch (error) {
        console.log(error)
        this.isLoadingCurrencyRate = false;
        this.isError = true;
      }
    },
    getExchangeRate(from, to) {
      if (this.currencyRate && this.currencyRate.data[from] && this.currencyRate.data[from][to]) {
        return this.currencyRate.data[from][to].value
      }
      return 0
    },
    openFileDialog() {
      this.$refs.uploader.click();
    },
    onUploadImage($event) {
      if ($event.target.files && $event.target.files[0]) {
        this.tempFiles.push($event.target.files[0]);
        this.$refs.uploader.value = null;
      }
    },
    fileToUrl(file) {
      return URL.createObjectURL(file);
    },
    removeFile(index) {
      this.tempFiles.splice(index, 1);
    },
    async preprarePostData() {
      this.isSaveing = true;
      let postData = {};
      postData.date = this.$moment(this.formData.date, "YYYY-MM-DD").toDate();
      postData.paymentMethod = this.formData.paymentMethod;
      postData.paymentNote = this.formData.paymentNote;
      postData.amount = this.formData.amount
      postData.paymentType = this.formData.paymentType
      postData.isSplitVatNonVat = this.formData.isSplitVatNonVat
      if (this.isDifferentCurrency) {
        postData.exchangeRate = this.formData.exchangeRate
        postData.totalPaymentValue = this.formData.totalPaymentValue
        postData.paymentCurrencyCode = this.formData.paymentCurrencyCode
      }
      if (this.formData.paymentType == 'split') {
        postData.splitType = this.formData.splitType
        if (this.formData.splitType == "item" || this.formData.splitType == "stall") {
          postData.items = this.tempReceipt.items
            .filter(d => d.name && d.accountingProduct)
            .map(d => {
              let obj = {};
              if (d.area) {
                if (!d.area.isRemove) {
                  obj.area = d.area;
                }
              }
              if (d.meter) obj.meter = d.meter;
              if (d.billingSetting) obj.billingSetting = d.billingSetting;
              if (d.accountingProduct) obj.accountingProduct = d.accountingProduct;
              if (d.dailyBillingSetting) obj.dailyBillingSetting = d.dailyBillingSetting;
              obj.name = d.name;
              obj.detail = d.detail;
              obj.unit = d.unit;
              obj.quantity = d.quantity;
              obj.sellVatType = d.sellVatType;
              obj.whtPercent = d.whtPercent;
              obj.totalValue = d.totalValue;
              obj.totalVatValue = d.totalVatValue;
              obj.totalNonVatValue = d.totalNonVatValue;
              obj.totalWhtValue = d.totalWhtValue;
              obj.type = d.type;
              obj.originalPricePerUnit = d.originalPricePerUnit;
              obj.discountType = d.discountType;
              obj.discountPerUnit = d.discountPerUnit;
              obj.totalDiscountValue = d.totalDiscountValue;
              return obj;
            });
          postData.isVatInclusive = this.tempReceipt.isVatInclusive
          postData.totalValue = this.tempReceipt.totalValue;
          postData.totalVatValue = this.tempReceipt.totalVatValue;
          postData.totalNonVatValue = this.tempReceipt.totalNonVatValue;
          postData.totalVatItemsValue = this.tempReceipt.totalVatItemsValue;
          postData.totalNonVatItemsValue = this.tempReceipt.totalNonVatItemsValue;
          postData.totalWhtValue = this.tempReceipt.totalWhtValue;
          postData.totalDiscountValue = this.tempReceipt.totalDiscountValue;
          postData.currencyCode = this.currencyCode;
        }
      }

      if (this.bankAccounts && this.formData.paymentBankAccount) {
        if (this.formData.paymentMethod == 2 || this.formData.paymentMethod == 6) {
          let obj = this.bankAccounts.find(
            (d) => d.objectId == this.formData.paymentBankAccount
          );
          if (obj) {
            postData.paymentBankAccount = {
              bankCode: obj.bankCode,
              accountName: obj.accountName,
              accountNumber: obj.accountNumber,
              accountBranch: obj.accountBranch,
            };
            if (obj.erpCode) postData.paymentBankAccount.erpCode = obj.erpCode
          }
        }

        if (this.formData.paymentMethod == 2) {
          postData.paymentProofFiles = []
          for (let file of this.tempFiles) {
            if (file.url) {
              postData.paymentProofFiles.push(file)
            } else {
              let uploaded = await FileUpload.upload(file);
              postData.paymentProofFiles.push(uploaded)
            }
          }
        }
      }

      if (this.formData.paymentMethod == 8) {
        postData.paymentProofFiles = []
        for (let file of this.tempFiles) {
          if (file.url) {
            postData.paymentProofFiles.push(file)
          } else {
            let uploaded = await FileUpload.upload(file);
            postData.paymentProofFiles.push(uploaded)
          }
        }
        postData.voucherNumber = this.formData.voucherNumber
      }
      this.isSaveing = false;
      return postData;
    },
    async onSubmit() {
      this.isSubmitFromQr = false
      this.$nextTick(async () => {
        this.$refs.form.validate()
        if (this.$refs.form.validate()) {
          if (this.isQrPayment) {
            this.dismiss()
          } else {
            let postData = await this.preprarePostData();
            if (this.contractCheckout) {
              await this.payContractCheckouts([this.contractCheckout])
              this.$emit("onSaveSuccess", postData);
              this.dismiss()
            } else if (this.contractCheckouts && this.contractCheckouts.length) {
              await this.payContractCheckouts(this.contractCheckouts)
              this.$emit("onSaveSuccess", postData);
              this.dismiss()
            } else {
              this.$emit("onSaveSuccess", postData);
              this.dismiss()
            }

          }
        }
      })
    },
    async payContractCheckouts(contractCheckouts) {
      this.isLoading = true
      if (contractCheckouts.length > 1) {
        this.isLoadingPercentDialog = true
        this.loadingInitial = contractCheckouts.length
        this.loadingFinal = 0
      }
      try {
        let postData = await this.preprarePostData();
        for (let contractCheckout of contractCheckouts) {
          await this.$store.dispatch("contractCheckout/payContractCheckout", {
            ...postData,
            id: contractCheckout.objectId
          })
          this.loadingFinal++
        }
        this.isLoadingPercentDialog = false
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.isLoadingPercentDialog = false
      }
    },
    onChageSplitVatNonVat() {
      localStorage.setItem("isSplitVatNonVat", this.formData.isSplitVatNonVat);
    },
    async saveQrCode() {
      let element = document.getElementById("thai-qr-code");
      let base64String = await htmlToImage.toPng(element, { quality: 1, canvasWidth: element.clientWidth * 2, canvasHeight: element.clientHeight * 2 })
      await saveAs(base64String, "image.png");
    },
    async printQrCode() {
      let element = document.getElementById("thai-qr-code");
      let base64String = await htmlToImage.toPng(element, { quality: 1, canvasWidth: element.clientWidth * 2, canvasHeight: element.clientHeight * 2 })
      let PDF = document.getElementById("iframe-qr-payment");
      PDF.contentWindow.document.body.innerHTML = `
        <div style="width: 100%; height: 100%; text-align: center;">
          <img src="${base64String}" style="height: 100%;">
        </div>
      `
      setTimeout(() => {
        PDF.focus();
        try {
          PDF.contentWindow.print();
        } catch (ex) {
          PDF.contentWindow.postMessage("print", "*");
        }
      }, 200)
    },
    async initQrPayment(lastQRPaymentReport) {
      this.isQrLoading = true
      this.qrPaymentData = null
      this.isStatus = false
      this.isExpired = false
      this.qrDuration = null
      this.expiredDateTime = null
      this.durationInquiry = 30
      this.qrCode = null
      this.qrPaymentReport = null
      if (this.intervalQrTime) clearInterval(this.intervalQrTime)
      try {
        let postData = await this.preprarePostData();
        let amount = this.paidValueWithWht
        if (lastQRPaymentReport) {
          this.qrPaymentData = lastQRPaymentReport.requestResult
        } else {
          this.qrPaymentData = await this.$store.dispatch("qrPayment/qrPaymentRequest", {
            invoiceId: this.invoice?.objectId,
            contractCheckoutId: this.contractCheckout?.objectId,
            orderId: this.order?.objectId,
            amount: amount,
            items: postData.items
          })
        }
        if (this.qrPaymentData && this.qrPaymentData.qrCode) {
          this.qrCode = await QRCode.toDataURL(this.qrPaymentData.qrCode)
          let mmExpired = this.$moment(this.qrPaymentData.requestResultAt?.iso).add(570, "seconds")
          this.expiredDateTime = this.$moment(mmExpired).toDate()
          let mm = this.$moment()
          let duration = mmExpired.diff(mm, "seconds")
          this.qrDuration = `${this.$helper.formatNumberLength(Math.floor(duration / 60), 2)}:` + this.$helper.formatNumberLength(duration % 60, 2)
          let _this = this
          this.intervalQrTime = setInterval(() => {
            mm = this.$moment()
            duration = mmExpired.diff(mm, "seconds")
            _this.qrDuration = `${_this.$helper.formatNumberLength(Math.floor(duration / 60), 2)}:` + _this.$helper.formatNumberLength(duration % 60, 2)
            if (duration <= 0) {
              _this.isExpired = true
            }
            if (_this.durationInquiry > 0) {
              _this.durationInquiry--
            }
          }, 1000);

          this.loopCheckStatus(postData)
          this.isQrLoading = false
        } else {
          this.isQrLoading = false
          this.isStatus = true
        }
      } catch (err) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
        this.qrPaymentData = {
          errorDesc: err.response.data.error
        }
        this.isStatus = true
        this.isQrLoading = false
      }
    },
    async loopCheckStatus(postData) {
      let _this = this
      do {
        this.qrPaymentReport = await checkStatus()
        if (this.qrPaymentReport && this.qrPaymentReport.result) {
          this.isStatus = true
          this.$emit("onSaveSuccess", postData);
          this.dismiss()
        }
      } while (!this.isStatus && !this.isExpired);

      async function checkStatus() {
        return new Promise((resolve, reject) => {
          try {
            if (_this.qrPaymentData?.partnerTxnUid) {
              _this.$store.dispatch("qrPayment/qrPaymentCheckStatus", _this.qrPaymentData?.partnerTxnUid).then((qrPaymentReport) => {
                setTimeout(() => {
                  resolve(qrPaymentReport)
                }, 3000)
              })
            } else {
              _this.isStatus = true
              _this.isExpired = true
              resolve()
            }
          } catch (err) {
            reject(err)
          }
        })
      }
    },
    async cancelQrPayment() {
      this.isCancelQrLoading = true
      try {
        if (this.qrPaymentData?.partnerTxnUid && this.qrPaymentData?.qrCode) {  
          await this.$store.dispatch("qrPayment/qrPaymentCancel", this.qrPaymentData.partnerTxnUid)
        }
        this.qrPaymentData = null
        this.isStatus = false
        this.isExpired = false
        this.qrDuration = "9:30"
        this.expiredDateTime = null
        this.durationInquiry = 30
        this.qrCode = null
        this.qrPaymentReport = null
        if (this.intervalQrTime) clearInterval(this.intervalQrTime)
        this.formData.paymentType = this.tempFormData.paymentType
        this.formData.splitType = this.tempFormData.splitType
        this.formData.paymentMethod = this.tempFormData.paymentMethod
        this.isCancelQrLoading = false
        this.isCancelQrDialog = false
      } catch (err) {
        console.log(err)
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
        this.isCancelQrDialog = false
        this.isCancelQrLoading = false
      }
    },
    dismiss() {
      this.$emit("input", false);
      this.isStatus = true
      this.isExpired = true
    },
    async onClickQrPayment() {
      this.tempFormData.paymentMethod = this.formData.paymentMethod
      if (!this.isQrPayment) {
        this.isSubmitFromQr = true
        this.$refs.form.validate()
        if (this.formData.paymentType === 'split' && (!this.checkValidateAmount() || !this.checkValidateItem())) {
          return false;
        }
        this.formData.paymentMethod = 7
        await this.initQrPayment()
      }
    },
    checkValidateAmount() {
      if (this.formData.splitType === 'amount') {
        if (!this.formData.amount) {
          this.$toast.show({
            content: this.$t('validate.please_input_amount_another_format'),
            color: "error"
          });
          return false
        } else if (this.formData.amount > this.totalUnpaidValue) {
          this.$toast.show({
            content: this.$t('validate.payment_amount_cannot_be_greater_than_the_outstanding_balance'),
            color: "error"
          });
          return false
        }
        this.formData.paymentMethod = this.tempFormData.paymentMethod
        return true
      } else {
        return true
      }
    },
    checkValidateItem() {
      if (this.formData.splitType === 'item') {
        if (!this.tempReceipt.items.length) {
          this.$toast.show({
            content: this.$t('validate.please_select_split_payment_list'),
            color: "error"
          });
          return false;
        } else if (this.tempReceipt.totalValue > this.totalUnpaidValue) {
          this.$toast.show({
            content: this.$t('validate.payment_amount_cannot_be_greater_than_the_outstanding_balance'),
            color: "error"
          });
          return false;
        }
        this.formData.paymentMethod = this.tempFormData.paymentMethod
        return true;
      } else {
        return true
      }
    },
    onClickPaymentType(type) {
      if (this.isQrPayment) {
        this.isCancelQrDialog = true
        this.tempFormData.paymentType = type
        this.tempFormData.splitType = this.formData.splitType
      } else {
        this.formData.paymentType = type
      }
    },
    onClickSplitType(type) {
      if (this.isQrPayment) {
        this.isCancelQrDialog = true
        this.tempFormData.splitType = type
        this.tempFormData.paymentType = this.formData.paymentType
      } else {
        this.formData.splitType = type
      }
    },
    onClickPaymentMethod(method) {
      if (this.isQrPayment) {
        this.isCancelQrDialog = true
        this.tempFormData.paymentMethod = method
        this.tempFormData.paymentType = this.formData.paymentType
        this.tempFormData.splitType = this.formData.splitType
      } else {
        this.formData.paymentMethod = method
      }
    },
    onClickSplitVatNonVat() {
      if (this.isQrPayment) {
        this.isCancelQrDialog = true
      }
    },
    onChangePaymentType(event) {
      event.preventDefault()
    },
    sumField(data, key, key2) {
      if (data && data.length && key && key2)
        return data.reduce((a, b) => a + (b[key] * b[key2] || 0), 0);
      else if (data && data.length && key && !key2)
        return data.reduce((a, b) => a + (b[key] || 0), 0);
      else return 0;
    },
    radioTypeExchange(type) {
      this.formData.exchangeRateType = type
    },
    changePaymentCurrencyCode(code) {
      if (code != this.currencyCode) {
        this.formData.manualExchangeRate = null
        this.formData.exchangeRate = this.getExchangeRate(code, this.currencyCode)
        this.formData.exchangeRateType = "auto"
        this.calPaymentTotalValue()
      }
    },  
    savePaymentRate() {
      if (!this.$refs.formPaymentRate.validate()) {
        return
      }
      this.menuPaymentRate = false
      if (this.formData.exchangeRateType === "auto") {
        this.formData.exchangeRate = this.getExchangeRate(this.formData.paymentCurrencyCode, this.currencyCode)
      } else {
        this.formData.exchangeRate = this.formData.manualExchangeRate
      }
      this.calPaymentTotalValue()
      this.$refs.manualExchangeRate.reset()
    },
    calPaymentTotalValue() {
      this.formData.totalPaymentValue = this.$helper.round(this.paidValue / parseFloat(this.formData.exchangeRate), 2)
    },
    buildGroupedStallData(items) {
      const grouped = {}

      items.forEach(item => {
        const stallId = item.area?.objectId || 'no-area'

        if (!grouped[stallId]) {
          grouped[stallId] = this.createStallGroup(item, stallId)
        }

        const { items: stallItems, totalValue } = grouped[stallId]
        stallItems.push(item)
        grouped[stallId].totalValue = totalValue + item.totalValue
      })

      return this.formatStallGroups(grouped)
    },
    createStallGroup(item, stallId) {
      const hasArea = stallId !== 'no-area'

      return {
        stallId,
        area: hasArea ? item.area : null,
        stallName: hasArea ? `${this.$t('area.title')} ${item.area.name}` : `${this.$t('area.not_specify_stall')}`,
        items: [],
        totalValue: 0,
        sellVatType: item.sellVatType,
        isNoArea: !hasArea
      }
    },
    formatStallGroups(grouped) {
      return Object.values(grouped).map(stall => ({
        ...stall,
        totalValue: parseFloat(stall.totalValue.toFixed(4))
      }))
    },
    isSameItem(item1, item2) {
      if (item1.id && item2.id) {
        return item1.id === item2.id
      }
      return (
        item1.name === item2.name &&
        item1.totalValue === item2.totalValue &&
        item1.area?.objectId === item2.area?.objectId
      )
    },
    isSelected(item) {
      return this.tempReceipt.items.some(selectedItem =>
        this.isSameItem(item, selectedItem)
      )
    },
    select(item, isSelected) {
      if (isSelected) {
        if (!this.isSelected(item)) {
          this.tempReceipt.items.push(item)
        }
      } else {
        const index = this.tempReceipt.items.findIndex(selectedItem =>
          this.isSameItem(item, selectedItem)
        )
        if (index !== -1) {
          this.tempReceipt.items.splice(index, 1)
        }
      }
    },
    isGroupSelected(stall) {
      if (!stall.items || stall.items.length === 0) return false
      return stall.items.every(item => this.isSelected(item))
    },
    isGroupIndeterminate(stall) {
      if (!stall.items || stall.items.length === 0) return false
      const selectedCount = stall.items.filter(item => this.isSelected(item)).length
      return selectedCount > 0 && selectedCount < stall.items.length
    },
    toggleGroupSelection(stall) {
      const shouldSelect = !this.isGroupSelected(stall)
      
      for (const item of stall.items) {
        this.select(item, shouldSelect)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 18px;
}

h1 {
  font-size: 20px;
}

.total-pay {
  font-size: 20px;
  font-weight: bold;
  color: var(--v-fontPrimary-base);
  background-color: var(--v-bgPrimary-base);
  padding: 12px 15px;
  border-radius: 6px;

}

.text-header {
  color: black;
  padding-left: 5px;
  font-size: 16px;
}

.text-sub-header {
  font-size: 16px;
}

.box-radio {
  padding: 15px 10px;
  border: 1px solid #A9A9A9;
  border-radius: 8px;
  width: 100%;

  &.v-item--active {
    border: 1px solid var(--v-fontPrimary-base);
  }

  &.v-radio--is-disabled {
    border: 1px solid #A9A9A9;
    opacity: 0.5;
  }
}

.c-1 {
  border-right: 1px solid #f2f2f2;
  padding: 0;
}

.c-2 {
  border-left: 1px solid #f2f2f2;
  padding: 0;
}

.box-bg-input {
  background-color: #E9F5EA;
  padding: 15px;
}

.col-item-split {
  background-color: white;
  text-align: center;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.split-total {
  color: var(--default-green);
  font-size: 20px;
  font-weight: bold;
}

.bank-name {
  color: black;
  font-size: 16px;
  line-height: 20px;
}

.bank-branch {
  color: var(--v-darkgray-base);
  font-size: 14px;
}

.box-upload {
  border: 1px dashed #A9A9A9;
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-upload {
  color: var(--v-fontPrimary-base);
  background-color: var(--v-bgPrimary-base);
  padding: 7px 20px;
  width: fit-content;
  height: fit-content;
  margin: 0 auto;
  border-radius: 10px;
  display: flex;
  align-items: center;

  .text-upload {
    color: var(--v-fontPrimary-base);
  }
}

.box-qr {
  max-width: 270px;
  text-align: center;
  margin: 0 auto;
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid #E4E6E8;
  background-color: white;
  position: relative;
}

.box-img-qr {
  padding: 0 3%;
  margin-top: -5%;
  margin-bottom: -6%;
}

.qrcode {
  width: 100%;
}

.text-qr-detail {
  font-size: 12px;
  color: black;
}

#thai-qr-code {
  width: fit-content;
}

.box-wht {
  border: 2px solid var(--v-fontPrimary-base);
  border-radius: 6px;
  padding: 5px 15px;
  color: var(--v-fontPrimary-base);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.header-qr-code {
  margin-bottom: 10px;
  color: #000;

  .txt-title {
    font-size: 14px;
    font-weight: bold;
  }

  .txt-sub {
    font-size: 12px;
  }
}

.txt-title {
  font-size: 14px;
  color: #000;
  font-weight: 500;
}

.txt-sub-title {
  font-size: 12px;
  color: #424242;
  font-weight: 500;
}

.txt-title-grey {
  font-size: 13px;
  color: #424242;
  font-weight: 500;
}

.box-qr-expired {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-currency{
  border-radius: 50%;
  margin-top: 3px;
}

.icon-currency-avatar{
  height: 20px !important;
  min-width: 20px !important;
  width: 20px !important;
  margin-right: 5px !important;
}

.main-card-exchange{
  max-width: 540px !important;
  width: 100% !important;
}
.container-card-exchange{
  .header-card-exchange{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-card-exchange{
      font-size: 16px;
      font-weight: bold;
      color: #424242;
    }
    .close-card-exchange{
      cursor: pointer;
    }
  }
  .body-card-exchange {
    margin-top: 15px;
    .box-radio-exchange {
      padding: 15px 10px;
      border: 1px solid #A9A9A9;
      border-radius: 8px;
      width: 100%;
      color: #424242;
      cursor: pointer;
      user-select: none;
      &.active{
        border: 1px solid var(--v-fontPrimary-base);
        background-color: #E8F5E9;
      }
  
      .icon-calendar{
        border: 1px solid #E4E6E8;
        border-radius: 3px;
        padding: 3px;
        background-color: #fff;
        cursor: pointer
      }
    }
  }
}
.grid-container-payment{
  display: grid;
  grid-template-columns: 50% 50%;
  min-height: 600px;
  .grd-1{
    border-right: 1px solid #f2f2f2;
    position: relative;
  }
  .grd-2{
    border-left: 1px solid #f2f2f2;
  }
  .header-payment-fixed{
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: #fff;
    padding: 10px;
    border-bottom: 1px solid #E4E6E8;
  }
  .body-payment{
    padding: 12px;
    overflow-y: auto;
  }
}

.header-payment-fixed{
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #fff;
  padding: 10px;
  border-bottom: 1px solid #E4E6E8;
}
.body-payment{
  padding: 12px;
}

::v-deep(.split-item-table .v-data-table__wrapper table thead tr:last-child th) {
  border-bottom: 0 !important;
}

.group-name-table{
  background-color: #FAFAFA !important;
  border-bottom: 0 !important;
}

.group-name {
  color: #777777;
}
</style>